@if (frontendSettings) {

<div *ngIf="!frontendSettings.toggle.tripPlanner">
  <div class="w-full h-full flex items-center justify-center absolute z-[200] top-0 left-0 bg-white">
    <p class="text-gray-600 text-2xl font-semibold">Trip Planner is not enabled, please contact your ITI support.</p>
  </div>
</div>

<div *ngIf="isShowGDPR"
  class="fixed bottom-0 left-0 z-[101] bg-white border border-t-[3px] border-blue-400 w-full h-auto p-8 overflow-hidden mobile:p-4">
  <div class="flex items-center gap-6 relative mobile:flex-col">
    <span class="text-gray-600">When you log in with Google or Facebook, you agree to allow our system to
      save your trip preferences. We place a cookie to know how each user uses
      our site and which items they saved on their trip. The data is anonymized
      to us, and Google or Facebook solely manages your email details. Please
      let us know if this is okay with you.</span>
    <ig-button (trigger)="acceptCookie()" mode="flat" cls="w-[200px] !h-[48px]">Accept Cookies</ig-button>

    <span class="absolute -top-7 -right-5 scale-x-[1.4] text-gray-600 cursor-pointer mobile:-top-2 mobile:-right-2"
      (click)="acceptCookie()">X</span>
  </div>
</div>

<div *ngIf="isMobile && isShowingMobileLandingPage" class="w-full h-full z-[100] bg-white overflow-y-auto">
  <!-- <div class="ig-tp-mobile-banner flex items-center justify-center h-[25vh]">
    <div class="text-center translate-y-[-3vh]">
      <b class="text-3xl text-white block">{{ hubName }}</b>
      <b class="text-3xl text-white block">TRIP PLANNER</b>
    </div>
  </div> -->

  <div class="relative">
    <div class="ig-tp-mobile-banner flex items-center justify-center h-[25vh]" [ngStyle]="{
        backgroundImage:
          'url(&quot;' +
          (frontendSettings.customSettings.tripPlanner.mobileLandingPage
            .bannerImage || defaultBannerImage) +
          '&quot;)'
      }">
      <div class="text-center">
        <b class="text-3xl text-white block">{{
          frontendSettings.customSettings.tripPlanner.mobileLandingPage
          .bannerText1 || hubName
          }}</b>
        <b class="text-3xl text-white block">{{
          frontendSettings.customSettings.tripPlanner.mobileLandingPage
          .bannerText2 || "TRIP PLANNER"
          }}</b>
      </div>
    </div>
  </div>

  <div class="w-[90%] mx-auto -translate-y-[57px] flex flex-col gap-8">
    <div class="shadow-lg rounded-2xl bg-white p-3">
      <ig-button mode="flat" cls="w-full !text-[13px]" #loginMenuTrigger="matMenuTrigger"
        [matMenuTriggerFor]="loginMenu" (trigger)="goto('trip')">Start by creating your first trip
      </ig-button>

      <mat-menu #loginMenu="matMenu" class="ig-text-color-edit !rounded-md px-6 py-2">
        <div igClickStopPropagation (keydown)="onKeyDown($event)">
          <p>Login in to start your trip</p>
          <ig-social-login #socialLogin (onLoginStatusChanged)="loginStatusChanged($event)"></ig-social-login>
        </div>
      </mat-menu>

      <hr class="border-b border-gray-200 my-2" />
      <div *ngIf="frontendSettings?.ai?.travelBuddy?.cityName" class="flex flex-col gap-2">
        <p class="text-xs text-gray-500 text-center">
          Need ideas? Try out AI suggested itineraries!
        </p>
        <div class="flex gap-3 overflow-x-auto">
          @if
          (frontendSettings.customSettings.tripPlanner.defaultAISuggestedItineraries?.length
          > 0) { @for (itinerary of
          frontendSettings.customSettings.tripPlanner.defaultAISuggestedItineraries; let i =
          $index; track i) {
          <div class="text-xs bg-gray-100 p-2 rounded-sm text-gray-600 whitespace-nowrap"
            (click)="createAITrip(itinerary.title)">
            {{ itinerary.title }}
          </div>
          } } @else {
          <div class="text-xs bg-gray-100 p-2 rounded-sm text-gray-600 whitespace-nowrap"
            (click)="createAITrip('one-day')">
            Suggest a one-day itinerary in
            {{ frontendSettings.ai.travelBuddy.cityName }}
          </div>
          <div class="text-xs bg-gray-100 p-2 rounded-sm text-gray-600 whitespace-nowrap"
            (click)="createAITrip('foodie')">
            Suggest a foodie itinerary in
            {{ frontendSettings.ai.travelBuddy.cityName }}
          </div>
          <div class="text-xs bg-gray-100 p-2 rounded-sm text-gray-600 whitespace-nowrap"
            (click)="createAITrip('kid-friendly')">
            Suggest a kid-friendly itinerary in
            {{ frontendSettings.ai.travelBuddy.cityName }}
          </div>
          }
        </div>
      </div>
    </div>

    <div (click)="goto('event')">
      <p class="text-gray-600 text-lg mb-2 font-semibold">Events to Explore</p>
      <ig-image [src]="
          frontendSettings.customSettings.tripPlanner.mobileLandingPage
            .eventImage || defaultEventImage
        " cls="rounded-lg aspect-7-4"></ig-image>
    </div>

    <div (click)="goto('place')">
      <p class="text-gray-600 text-lg mb-2 font-semibold">Places to Visit</p>
      <ig-image [src]="
          frontendSettings.customSettings.tripPlanner.mobileLandingPage
            .placeImage || defaultPlaceImage
        " cls="rounded-lg aspect-7-4"></ig-image>
    </div>

    <div (click)="goto('itinerary')">
      <p class="text-gray-600 text-lg mb-2 font-semibold">
        Suggested Itineraries
      </p>
      <ig-image [src]="
          frontendSettings.customSettings.tripPlanner.mobileLandingPage
            .itineraryImage || defaultItineraryImage
        " cls="rounded-lg aspect-7-4"></ig-image>
    </div>

    <div (click)="goto('trip')">
      <p class="text-gray-600 text-lg mb-2 font-semibold">My Trips</p>
      <ig-image [src]="
          frontendSettings.customSettings.tripPlanner.mobileLandingPage
            .tripImage || defaultTripImage
        " cls="rounded-lg aspect-7-4"></ig-image>
    </div>
  </div>
</div>

<div class="w-full h-full relative flex items-center justify-center bg-transparent ig-tp-container"
  [class.script-mobile]="mediaQueryService.isMobile$ | async"
  [class.script-desktop-sm]="mediaQueryService.isDesktopSm$ | async"
  [class.script-desktop-lg]="mediaQueryService.isDesktopLg$ | async"
  [class.script-desktop-xl]="mediaQueryService.isDesktopXl$ | async"
  [class.script-desktop-2xl]="mediaQueryService.isDesktop2Xl$ | async"
  [class.script-desktop-3xl]="mediaQueryService.isDesktop3Xl$ | async">

  @if (isShowTravelBuddy) {
  @defer (on timer(2000)) {
  <ig-ai-buddy-place-listing></ig-ai-buddy-place-listing>
  }
  }

  <div class="w-[90vw] max-w-[2000px] min-w-[1080px] h-[90vh] rounded-3xl bg-gray-100 relative flex items-center justify-center border border-solid border-gray-200
      mobile:min-w-[unset] mobile:w-[100%] mobile:h-full smallDesktop:w-[96%]">
    <div class="w-full h-full flex justify-start rounded-l-3xl">
      <div
        class="w-[22%] min-w-[250px] h-full ig-tp-sidebar p-6 bg-[#e1ecf7] rounded-l-3xl flex flex-col gap-3 border-r-[1px] border-dashed relative justify-between transition-all duration-150 smallDesktop:w-[20%] 2xl:w-[18%] mobile:z-50 mobile:rounded-none"
        [class.!w-0]="!isSidebarOpen && isMobile" [class.!min-w-0]="!isSidebarOpen && isMobile"
        [class.!px-0]="!isSidebarOpen && isMobile">

        <div class="flex flex-col gap-3 relative">
          <mat-icon *ngIf="isSidebarOpen && isMobile" class="absolute -right-4 -top-4 text-[24px] cursor-pointer"
            (click)="toggleSidebar()">close
          </mat-icon>

          <div class="scale-[0.45] -translate-x-[115px] -translate-y-2 absolute ig-iti-logo"
            [class.ig-hide]="isMobile && !isSidebarOpen">
            <svg width="429" height="75.03858179376753" viewBox="0 0 370.3448275862069 64.77890591311497"
              class="looka-1j8o68f">
              <defs id="SvgjsDefs3755">
                <linearGradient id="SvgjsLinearGradient3762">
                  <stop id="SvgjsStop3763" stop-color="#2d388a" offset="0"></stop>
                  <stop id="SvgjsStop3764" stop-color="#00aeef" offset="1"></stop>
                </linearGradient>
                <linearGradient id="SvgjsLinearGradient3765">
                  <stop id="SvgjsStop3766" stop-color="#2d388a" offset="0"></stop>
                  <stop id="SvgjsStop3767" stop-color="#00aeef" offset="1"></stop>
                </linearGradient>
                <linearGradient id="SvgjsLinearGradient3768">
                  <stop id="SvgjsStop3769" stop-color="#2d388a" offset="0"></stop>
                  <stop id="SvgjsStop3770" stop-color="#00aeef" offset="1"></stop>
                </linearGradient>
              </defs>
              <g id="SvgjsG3756" featurekey="4yrtKO-0" [class.scale-50]="!isSidebarOpen"
                [class.ig-hide]="!isSidebarOpen && isMobile"
                transform="matrix(0.8590011044299914,0,0,0.8590011044299914,310.0000004609176,3.9997883373161724)"
                fill="url(#SvgjsLinearGradient3762)">
                <title xmlns="http://www.w3.org/2000/svg">Asset 9</title>
                <g xmlns="http://www.w3.org/2000/svg" data-name="Layer 2">
                  <g>
                    <path
                      d="M21.959,67.706.686,56.956A1.249,1.249,0,0,1,0,55.84V12.589a1.249,1.249,0,0,1,1.714-1.16l21.273,8.5a1.25,1.25,0,0,1,.786,1.16v.5H22.324l-.265.664L2.5,14.435V55.072l20.587,10.4Z">
                    </path>
                    <path
                      d="M69,68.09A1.269,1.269,0,0,1,68.524,68L46.557,58.952a1.253,1.253,0,0,1-.774-1.157V31.5h2.5V56.959L67.75,64.974V20.493l-5.306-2.252.976-2.3,6.068,2.576a1.25,1.25,0,0,1,.762,1.151V66.84A1.25,1.25,0,0,1,69,68.09Z">
                    </path>
                    <path d="M23.773,25.34h-2.5V21.089a1.25,1.25,0,0,1,.775-1.156l10.231-4.2.949,2.312-9.455,3.88Z">
                    </path>
                    <path
                      d="M22.523,67.84a1.249,1.249,0,0,1-1.25-1.25v-19h2.5V64.824l22.845-8.057L46.98,57.8h1.3v.151a1.25,1.25,0,0,1-.834,1.179L22.938,67.769A1.236,1.236,0,0,1,22.523,67.84Z">
                    </path>
                    <path
                      d="M57.151,42.9a1.268,1.268,0,0,1-.26-.027,1.253,1.253,0,0,1-.908-.778L48.535,22.581a1.251,1.251,0,0,1,.284-1.33l6.033-6.032a1.25,1.25,0,0,1,2.084.535l6.077,20.884a1.25,1.25,0,0,1-.317,1.233l-4.661,4.662A1.25,1.25,0,0,1,57.151,42.9ZM51.16,22.446,57.631,39.4l2.775-2.775L55.125,18.481Z">
                    </path>
                    <path
                      d="M42.417,16.1a1.255,1.255,0,0,1-.445-.082L22.459,8.57a1.251,1.251,0,0,1-.438-2.052l4.662-4.661a1.249,1.249,0,0,1,1.233-.316L48.8,7.618A1.25,1.25,0,0,1,49.334,9.7L43.3,15.734A1.248,1.248,0,0,1,42.417,16.1ZM25.153,6.922l16.953,6.472,3.966-3.966L27.927,4.147Z">
                    </path>
                    <path
                      d="M24.6,41.206a1.257,1.257,0,0,1-.446-.082L14.4,37.4a1.25,1.25,0,0,1-.438-2.052L19.3,30a1.254,1.254,0,0,1,1.233-.317l10.442,3.038a1.25,1.25,0,0,1,.534,2.084l-6.032,6.033A1.247,1.247,0,0,1,24.6,41.206Zm-7.509-5.455,7.2,2.748,3.966-3.966-7.7-2.242Z">
                    </path>
                    <path
                      d="M28.321,50.961a1.218,1.218,0,0,1-.261-.027,1.254,1.254,0,0,1-.907-.777L23.429,40.4a1.249,1.249,0,0,1,.284-1.329l6.033-6.033a1.249,1.249,0,0,1,2.084.534l3.039,10.443a1.251,1.251,0,0,1-.317,1.234L29.205,50.6A1.246,1.246,0,0,1,28.321,50.961ZM26.054,40.267l2.747,7.2L32.262,44l-1.377-4.729h0L30.02,36.3Z">
                    </path>
                    <path
                      d="M32.085,40.175a1.275,1.275,0,0,1-.5-.1,1.254,1.254,0,0,1-.7-.8l-1.264-4.344-4.343-1.263a1.252,1.252,0,0,1-.77-1.759,13.427,13.427,0,0,1,1.984-2.9L53.718,1.783C55.632-.134,61.557-.043,63.326.03a1.249,1.249,0,0,1,1.2,1.2c.073,1.77.163,7.692-1.752,9.608l-27.2,27.2a13.392,13.392,0,0,1-2.93,2.011A1.259,1.259,0,0,1,32.085,40.175Zm-4.557-8.456,3.451,1a1.252,1.252,0,0,1,.851.851l1,3.451a10.263,10.263,0,0,0,1-.788L61,9.068c.675-.675,1.05-3.723,1.046-6.565H62c-2.828,0-5.845.375-6.516,1.047l-27.2,27.2h0A10.514,10.514,0,0,0,27.528,31.719Z">
                    </path>
                    <path
                      d="M30.629,35.172a1.25,1.25,0,0,1-.883-2.133l4.84-4.84a1.25,1.25,0,0,1,1.768,1.767l-4.841,4.84A1.246,1.246,0,0,1,30.629,35.172Z">
                    </path>
                    <path
                      d="M33.572,8.808a1.25,1.25,0,0,1-.884-2.134L37.263,2.1a1.25,1.25,0,0,1,1.768,1.768L34.456,8.442A1.248,1.248,0,0,1,33.572,8.808Z">
                    </path>
                    <path
                      d="M58.354,33.589a1.25,1.25,0,0,1-.884-2.133l4.575-4.576a1.25,1.25,0,0,1,1.767,1.768l-4.575,4.575A1.246,1.246,0,0,1,58.354,33.589Z">
                    </path>
                  </g>
                </g>
              </g>
              <g *ngIf="isSidebarOpen" id="SvgjsG3757" featurekey="Gem1BN-0"
                transform="matrix(1.3420524021517943,0,0,1.3420524021517943,-1.0199598128365546,-8.723341253927117)"
                fill="url(#SvgjsLinearGradient3765)">
                <path
                  d="M0.76 20 l0 -2.32 l1.48 0 l0 -8.58 l-1.48 0 l0 -2.32 l10.56 0 l0 4.26 l-2.52 0 l0 -1.74 l-3.22 0 l0 2.78 l3.78 0 l0 2.52 l-3.78 0 l0 2.88 l3.34 0 l0 -1.94 l2.52 0 l0 4.46 l-10.68 0 z M14.638000000000002 20 l0 -2.32 l1.18 0 l3.26 -4.78 l-3 -3.8 l-1.24 0 l0 -2.32 l5.86 0 l0 2.32 l-0.92 0 l1.74 2.3 l1.54 -2.3 l-0.92 0 l0 -2.32 l5.58 0 l0 2.32 l-1.34 0 l-3.1 4.54 l3.22 4.04 l1.12 0 l0 2.32 l-5.7 0 l0 -2.32 l0.92 0 l-2 -2.54 l-1.7 2.54 l0.92 0 l0 2.32 l-5.42 0 z M30.876000000000005 20 l0 -2.32 l1.44 0 l0 -8.58 l-1.44 0 l0 -2.32 l6.24 0 c3.88 0 5.42 1.62 5.42 4.52 c0 2.7 -1.5 4.48 -5.7 4.48 l-1.16 0 l0 1.9 l1.64 0 l0 2.32 l-6.44 0 z M35.676 13.26 l1.14 0 c1.48 0 2.22 -0.58 2.22 -2 c0 -1.52 -0.84 -1.98 -2.04 -1.98 l-1.32 0 l0 3.98 z M45.594 20 l0 -2.32 l1.48 0 l0 -8.58 l-1.44 0 l0 -2.32 l6.24 0 l0 2.32 l-1.44 0 l0 8.38 l3.46 0 l0 -2.04 l2.52 0 l0 4.56 l-10.82 0 z M65.792 20.28 c-4.3 0 -6.52 -2.92 -6.52 -6.92 c0 -4.1 2.32 -6.86 6.64 -6.86 c4.08 0 6.54 2.46 6.54 6.7 c0 4.1 -2.32 7.08 -6.66 7.08 z M65.852 17.5 c1.88 0 3.06 -1.24 3.06 -4.16 c0 -2.88 -1.14 -4.06 -3.02 -4.06 c-1.94 0 -3.08 1.26 -3.08 4.1 c0 2.88 1.16 4.12 3.04 4.12 z M75.79 20 l0 -2.32 l1.44 0 l0 -8.58 l-1.44 0 l0 -2.32 l6.62 0 c3.66 0 4.96 1.64 4.96 3.76 c0 1.98 -1.12 3.04 -2.34 3.62 c0.52 0.28 0.9 0.8 1.24 1.74 c0.28 0.78 0.4 1.5 1.7 1.5 l0.16 0 l-0.58 2.72 c-0.28 0.04 -0.54 0.06 -0.78 0.06 c-2.52 0 -3.16 -1.82 -3.66 -3.16 c-0.58 -1.82 -0.78 -1.98 -1.9 -1.98 l-0.62 0 l0 2.64 l1.44 0 l0 2.32 l-6.24 0 z M80.59 12.52 l1.74 0 c1.22 0 1.68 -0.76 1.68 -1.54 c0 -1.22 -0.56 -1.68 -1.68 -1.68 l-1.74 0 l0 3.22 z M91.20800000000001 20 l0 -2.32 l1.48 0 l0 -8.58 l-1.48 0 l0 -2.32 l10.56 0 l0 4.26 l-2.52 0 l0 -1.74 l-3.22 0 l0 2.78 l3.78 0 l0 2.52 l-3.78 0 l0 2.88 l3.34 0 l0 -1.94 l2.52 0 l0 4.46 l-10.68 0 z M113.86400000000002 20 l0 -2.32 l1.44 0 l0 -8.38 l-2.02 0 l0 2.04 l-2.52 0 l0 -4.56 l12.44 0 l0 4.56 l-2.52 0 l0 -2.04 l-2.02 0 l0 8.38 l1.44 0 l0 2.32 l-6.24 0 z M126.24200000000002 20 l0 -2.32 l1.44 0 l0 -8.58 l-1.44 0 l0 -2.32 l6.24 0 l0 2.32 l-1.44 0 l0 2.98 l5.4 0 l0 -2.98 l-1.44 0 l0 -2.32 l6.24 0 l0 2.32 l-1.44 0 l0 8.58 l1.44 0 l0 2.32 l-6.24 0 l0 -2.32 l1.44 0 l0 -3.08 l-5.4 0 l0 3.08 l1.44 0 l0 2.32 l-6.24 0 z M144.72 20 l0 -2.32 l1.48 0 l0 -8.58 l-1.48 0 l0 -2.32 l10.56 0 l0 4.26 l-2.52 0 l0 -1.74 l-3.22 0 l0 2.78 l3.78 0 l0 2.52 l-3.78 0 l0 2.88 l3.34 0 l0 -1.94 l2.52 0 l0 4.46 l-10.68 0 z M167.37599999999998 20 l0 -2.32 l1.44 0 l0 -8.38 l-2.02 0 l0 2.04 l-2.52 0 l0 -4.56 l12.44 0 l0 4.56 l-2.52 0 l0 -2.04 l-2.02 0 l0 8.38 l1.44 0 l0 2.32 l-6.24 0 z M179.754 20 l0 -2.32 l1.44 0 l0 -8.58 l-1.44 0 l0 -2.32 l6.62 0 c3.66 0 4.96 1.64 4.96 3.76 c0 1.98 -1.12 3.04 -2.34 3.62 c0.52 0.28 0.9 0.8 1.24 1.74 c0.28 0.78 0.4 1.5 1.7 1.5 l0.16 0 l-0.58 2.72 c-0.28 0.04 -0.54 0.06 -0.78 0.06 c-2.52 0 -3.16 -1.82 -3.66 -3.16 c-0.58 -1.82 -0.78 -1.98 -1.9 -1.98 l-0.62 0 l0 2.64 l1.44 0 l0 2.32 l-6.24 0 z M184.554 12.52 l1.74 0 c1.22 0 1.68 -0.76 1.68 -1.54 c0 -1.22 -0.56 -1.68 -1.68 -1.68 l-1.74 0 l0 3.22 z M195.19199999999998 20 l0 -2.32 l1.44 0 l0 -8.58 l-1.44 0 l0 -2.32 l6.24 0 l0 2.32 l-1.44 0 l0 8.58 l1.44 0 l0 2.32 l-6.24 0 z M204.92999999999998 20 l0 -2.32 l1.44 0 l0 -8.58 l-1.44 0 l0 -2.32 l6.24 0 c3.88 0 5.42 1.62 5.42 4.52 c0 2.7 -1.5 4.48 -5.7 4.48 l-1.16 0 l0 1.9 l1.64 0 l0 2.32 l-6.44 0 z M209.73 13.26 l1.14 0 c1.48 0 2.22 -0.58 2.22 -2 c0 -1.52 -0.84 -1.98 -2.04 -1.98 l-1.32 0 l0 3.98 z">
                </path>
              </g>
              <g *ngIf="isSidebarOpen" id="SvgjsG3758" featurekey="Gem1BN-1"
                transform="matrix(2.7078674569342125,0,0,2.7078674569342125,-2.1121365389359763,9.640656782641013)"
                fill="url(#SvgjsLinearGradient3768)">
                <path
                  d="M0.78 20 l0 -2.32 l1.44 0 l0 -8.58 l-1.44 0 l0 -2.32 l6.24 0 c3.88 0 5.42 1.62 5.42 4.52 c0 2.7 -1.5 4.48 -5.7 4.48 l-1.16 0 l0 1.9 l1.64 0 l0 2.32 l-6.44 0 z M5.58 13.26 l1.14 0 c1.48 0 2.22 -0.58 2.22 -2 c0 -1.52 -0.84 -1.98 -2.04 -1.98 l-1.32 0 l0 3.98 z M15.498000000000001 20 l0 -2.32 l1.48 0 l0 -8.58 l-1.44 0 l0 -2.32 l6.24 0 l0 2.32 l-1.44 0 l0 8.38 l3.46 0 l0 -2.04 l2.52 0 l0 4.56 l-10.82 0 z M28.856000000000005 20 l0 -2.32 l1.02 0 l3.92 -10.9 l3.08 0 l4.34 10.9 l1.04 0 l0 2.32 l-5.52 0 l0 -2.32 l1.24 0 l-0.5 -1.32 l-4.24 0 l-0.44 1.32 l1.26 0 l0 2.32 l-5.2 0 z M33.976000000000006 14.04 l2.66 0 l-1.42 -4.02 z M45.074000000000005 20 l0 -2.32 l1.44 0 l0 -8.58 l-1.44 0 l0 -2.32 l4.7 0 l5.44 8.04 l0 -5.72 l-1.44 0 l0 -2.32 l6.08 0 l0 2.32 l-1.44 0 l0 10.9 l-3.28 0 l-5.42 -7.92 l0 5.6 l1.44 0 l0 2.32 l-6.08 0 z M63.132000000000005 20 l0 -2.32 l1.44 0 l0 -8.58 l-1.44 0 l0 -2.32 l4.7 0 l5.44 8.04 l0 -5.72 l-1.44 0 l0 -2.32 l6.08 0 l0 2.32 l-1.44 0 l0 10.9 l-3.28 0 l-5.42 -7.92 l0 5.6 l1.44 0 l0 2.32 l-6.08 0 z M81.17 20 l0 -2.32 l1.48 0 l0 -8.58 l-1.48 0 l0 -2.32 l10.56 0 l0 4.26 l-2.52 0 l0 -1.74 l-3.22 0 l0 2.78 l3.78 0 l0 2.52 l-3.78 0 l0 2.88 l3.34 0 l0 -1.94 l2.52 0 l0 4.46 l-10.68 0 z M95.408 20 l0 -2.32 l1.44 0 l0 -8.58 l-1.44 0 l0 -2.32 l6.62 0 c3.66 0 4.96 1.64 4.96 3.76 c0 1.98 -1.12 3.04 -2.34 3.62 c0.52 0.28 0.9 0.8 1.24 1.74 c0.28 0.78 0.4 1.5 1.7 1.5 l0.16 0 l-0.58 2.72 c-0.28 0.04 -0.54 0.06 -0.78 0.06 c-2.52 0 -3.16 -1.82 -3.66 -3.16 c-0.58 -1.82 -0.78 -1.98 -1.9 -1.98 l-0.62 0 l0 2.64 l1.44 0 l0 2.32 l-6.24 0 z M100.208 12.52 l1.74 0 c1.22 0 1.68 -0.76 1.68 -1.54 c0 -1.22 -0.56 -1.68 -1.68 -1.68 l-1.74 0 l0 3.22 z">
                </path>
              </g>
            </svg>
          </div>

          <div class="flex flex-col gap-3 mt-[76px]">
            <div *ngIf="frontendSettings.toggle.eventByGeolocation || frontendSettings.toggle.manualEvents"
              class="flex items-center gap-[22px] cursor-pointer text-gray-500"
              [class.!text-blue-500]="displayingOn === 'event'" (click)="goto('event')">
              <mat-icon [class.!text-blue-500]="displayingOn === 'event'" matTooltipPosition="left"
                [class.ig-rotate-360]="displayingOn === 'event'" [matTooltip]="isSidebarOpen ? '' : 'Events'">
                receipt
              </mat-icon>
              <p class="text-lg font-semibold overflow-hidden">EVENTS</p>
            </div>
            <div *ngIf="frontendSettings.toggle.placeCalendar"
              class="flex items-center gap-[22px] cursor-pointer text-gray-500"
              [class.!text-blue-500]="displayingOn === 'place'" (click)="goto('place')">
              <mat-icon [class.!text-blue-500]="displayingOn === 'place'" matTooltipPosition="left"
                [class.ig-rotate-360]="displayingOn === 'place'" [matTooltip]="isSidebarOpen ? '' : 'Places'">
                room
              </mat-icon>
              <p class="text-lg font-semibold overflow-hidden transition-all duration-150">
                PLACES
              </p>
            </div>
            <div *ngIf="frontendSettings.toggle.itinerary"
              class="flex items-center gap-[22px] cursor-pointer text-gray-500" (click)="goto('itinerary')"
              [class.!text-blue-500]="displayingOn === 'itinerary'">
              <mat-icon [class.!text-blue-500]="displayingOn === 'itinerary'"
                [class.ig-rotate-360]="displayingOn === 'itinerary'" [matTooltip]="isSidebarOpen ? '' : 'Itineraries'"
                matTooltipPosition="left">stars
              </mat-icon>
              <p class="text-lg font-semibold overflow-hidden transition-all duration-150">
                ITINERARIES
              </p>
            </div>
            <div class="flex items-center gap-[22px] cursor-pointer text-gray-500"
              [class.!text-blue-500]="displayingOn === 'trip'" (click)="goto('trip')">
              <mat-icon [class.!text-blue-500]="displayingOn === 'trip'" [class.ig-rotate-360]="displayingOn === 'trip'"
                [matTooltip]="isSidebarOpen ? '' : 'My Trips'" matTooltipPosition="left">
                flight_takeoff
              </mat-icon>
              <p class="text-lg font-semibold overflow-hidden transition-all duration-150">
                MY TRIPS
              </p>
            </div>
          </div>

        </div>

        <div class="flex flex-col gap-2 text-blue-500 text-sm overflow-hidden">
          <div *ngIf="isSidebarOpen" class="font-semibold text-gray-500 border-b border-gray-400 pb-2 mb-2 w-full">
            For Industry Partners</div>
          <p *ngIf="frontendSettings.toggle.eventByGeolocation || frontendSettings.toggle.manualEvents"
            class="flex items-center gap-[22px] cursor-pointer text-gray-500" (click)="addEventsManually()">
            <mat-icon class="!text-[18px] translate-y-1 translate-x-[3px]"
              [matTooltip]="isSidebarOpen ? '' : 'Submit Your Events'" matTooltipPosition="left">today
            </mat-icon>
            <span class="hover:underline smallDesktop:text-[12px] ig-tp-submit">Submit Your Events</span>
          </p>
          <p *ngIf="frontendSettings.toggle.placeCalendar"
            class="flex items-center gap-[22px] cursor-pointer text-gray-500" (click)="addPlacesManually()">
            <mat-icon class="!text-[18px] translate-y-1 translate-x-[3px]"
              [matTooltip]="isSidebarOpen ? '' : 'Submit Your Places'" matTooltipPosition="left">fmd_good
            </mat-icon>
            <span class="hover:underline smallDesktop:text-[12px] ig-tp-submit">Submit Your Places</span>
          </p>

          <ig-powered-by *ngIf="isSidebarOpen" [style]="'iti-horizontal'" class="mt-4 scale-[0.8]"></ig-powered-by>
        </div>
      </div>

      <div
        class="w-[78%] h-full bg-[#f3f6fc] rounded-r-3xl absolute right-0 top-0 transition-all duration-150 flex smallDesktop:w-[80%] 2xl:w-[82%] mobile:w-full mobile:rounded-none"
        [class.!w-[calc(100%-70px)]]="!isSidebarOpen && !isMobile" [class.!w-full]="!isSidebarOpen && isMobile">
        <div *ngIf="!isMobile" class="relative h-full w-0">
          <mat-icon class="absolute z-10 top-[50%] -left-3 !text-gray-400 cursor-pointer !w-6 !h-6 text-[24px]"
            (click)="toggleSidebar()">
            {{ isSidebarOpen ? "arrow_circle_left" : "arrow_circle_right" }}
          </mat-icon>
        </div>

        <div class="w-full h-full bg-[#f3f6fc] rounded-r-3xl">
          <div class="h-[6vh] flex items-center w-full px-8 bg-white rounded-tr-3xl mobile:h-[68px] mobile:pt-[13px]">
            <div class="flex justify-between items-center relative w-full">
              <b *ngIf="!isMobile" class="text-blue-400 uppercase">{{getDisplayOn}}</b>

              <div class="mobile:hidden"></div>
              <div class="flex items-center gap-4">
                <div class="h-full hidden mobile:block">
                  <mat-icon class="!text-gray-500 cursor-pointer !w-8 !h-8 text-[32px] leading-[36px]"
                    (click)="toggleSideBarOrCloseMap()">
                    {{
                    !isSidebarOpen
                    ? isShowingMapOnMobile
                    ? "chevron_left"
                    : "menu"
                    : "menu"
                    }}
                  </mat-icon>
                </div>
                <b class="uppercase text-blue-400 hidden mobile:block">{{
                  getDisplayOn
                  }}</b>
              </div>
              <!-- <svg width="255.6666732788086" height="61.42677751768999" viewBox="0 0 367.5 88.29598495668378"
                class="scale-[0.6] absolute -left-5 mobile:hidden">
                <defs id="SvgjsDefs4335">
                  <linearGradient id="SvgjsLinearGradient4342">
                    <stop id="SvgjsStop4343" stop-color="#2d388a" offset="0"></stop>
                    <stop id="SvgjsStop4344" stop-color="#00aeef" offset="1"></stop>
                  </linearGradient>
                  <linearGradient id="SvgjsLinearGradient4345">
                    <stop id="SvgjsStop4346" stop-color="#2d388a" offset="0"></stop>
                    <stop id="SvgjsStop4347" stop-color="#00aeef" offset="1"></stop>
                  </linearGradient>
                  <linearGradient id="SvgjsLinearGradient4348">
                    <stop id="SvgjsStop4349" stop-color="#2d388a" offset="0"></stop>
                    <stop id="SvgjsStop4350" stop-color="#00aeef" offset="1"></stop>
                  </linearGradient>
                </defs>
                <g id="SvgjsG4336" featurekey="textGroupContainer" transform="matrix(1,0,0,1,0,11)"
                  fill="url(#SvgjsLinearGradient4342)">
                  <rect xmlns="http://www.w3.org/2000/svg" y="0" x="0" height="1" width="1" opacity="0"></rect>
                  <rect xmlns="http://www.w3.org/2000/svg" y="63.6578947368421" x="0" width="62.5" height="2"></rect>
                  <rect xmlns="http://www.w3.org/2000/svg" y="63.6578947368421" x="305" width="62.5" height="2"></rect>
                </g>
                <g id="SvgjsG4337" featurekey="nameFeature-0"
                  transform="matrix(1.6711228534224558,0,0,1.6711228534224558,8.999999950196662,-17.647053252251354)"
                  fill="url(#SvgjsLinearGradient4345)">
                  <path
                    d="M1.12 12.719999999999999 q-0.44 0 -0.78 -0.3 t-0.34 -0.74 t0.34 -0.76 t0.78 -0.32 l16.84 0 q0.56 0 0.84 0.34 t0.28 0.72 t-0.28 0.72 t-0.84 0.34 l-5.6 0 l0 26.24 q0 0.44 -0.32 0.74 t-0.8 0.3 l-3.48 0 q-0.48 0 -0.8 -0.3 t-0.32 -0.74 l0 -26.24 l-5.52 0 z M27.64 38.96 q0 0.44 -0.34 0.74 t-0.82 0.3 l-3.48 0 q-0.44 0 -0.78 -0.3 t-0.34 -0.74 l0 -27.28 q0 -0.44 0.34 -0.76 t0.78 -0.32 q2.04 0 4.1 0.02 t4.1 0.02 q1.64 0 3.08 0.58 t2.52 1.56 t1.7 2.32 t0.62 2.82 l0 4 q0 2.08 -1.16 3.8 t-3.04 2.64 q1.4 0.72 2.28 2.04 t0.88 2.92 l0 5.76 q0 0.36 -0.26 0.62 t-0.66 0.26 l-4.84 0 l0 -8.56 q0 -0.96 -0.46 -1.44 t-1.16 -0.66 t-1.52 -0.18 l-1.54 0 l0 9.84 z M27.64 12.36 l0 14.96 l2.8 0 q1.36 0 2.3 -0.88 t0.94 -2.12 l0 -8.96 q0 -1.24 -0.94 -2.12 t-2.3 -0.88 l-2.8 0 z M47.68 38.96 q0 0.44 -0.34 0.74 t-0.82 0.3 l-3.48 0 q-0.44 0 -0.78 -0.3 t-0.34 -0.74 l0 -27.28 q0 -0.44 0.34 -0.76 t0.78 -0.32 l3.48 0 q0.48 0 0.82 0.32 t0.34 0.76 l0 27.28 z M56.24 38.96 q0 0.44 -0.34 0.74 t-0.82 0.3 l-3.48 0 q-0.44 0 -0.78 -0.3 t-0.34 -0.74 l0 -27.28 q0 -0.44 0.34 -0.76 t0.78 -0.32 q2.04 0 4.1 0.02 t4.1 0.02 q1.64 0 3.08 0.58 t2.52 1.56 t1.7 2.32 t0.62 2.82 l0 3.88 q0 1.52 -0.62 2.86 t-1.7 2.32 t-2.52 1.56 t-3.08 0.58 l-3.56 0 l0 9.84 z M56.24 12.36 l0 15.08 l2.8 0 q1.36 0 2.3 -0.86 t0.94 -2.1 l0 -9.16 q0 -1.24 -0.94 -2.1 t-2.3 -0.86 l-2.8 0 z M84.28000000000002 38.96 q0 0.44 -0.34 0.74 t-0.82 0.3 l-3.48 0 q-0.44 0 -0.78 -0.3 t-0.34 -0.74 l0 -27.28 q0 -0.44 0.34 -0.76 t0.78 -0.32 q2.04 0 4.1 0.02 t4.1 0.02 q1.64 0 3.08 0.58 t2.52 1.56 t1.7 2.32 t0.62 2.82 l0 3.88 q0 1.52 -0.62 2.86 t-1.7 2.32 t-2.52 1.56 t-3.08 0.58 l-3.56 0 l0 9.84 z M84.28000000000002 12.36 l0 15.08 l2.8 0 q1.36 0 2.3 -0.86 t0.94 -2.1 l0 -9.16 q0 -1.24 -0.94 -2.1 t-2.3 -0.86 l-2.8 0 z M104.32000000000001 37.88 l5.92 0 q0.56 0 0.84 0.32 t0.28 0.72 t-0.28 0.72 t-0.84 0.32 l-10.56 0.04 q-0.44 0 -0.78 -0.3 t-0.34 -0.74 l0 -27.28 q0 -0.44 0.34 -0.76 t0.78 -0.32 l3.48 0 q0.48 0 0.82 0.32 t0.34 0.76 l0 26.2 z M123.8 14.399999999999999 l-2.72 17.44 l5.92 0 z M119.96 38.96 q-0.08 0.44 -0.5 0.74 t-0.86 0.3 l-3.48 0 q-0.48 0 -0.74 -0.3 t-0.18 -0.74 l5 -27.28 q0.08 -0.44 0.5 -0.76 t0.86 -0.32 l4 0 q0.48 0 0.9 0.32 t0.5 0.76 l4.72 27.28 q0.08 0.44 -0.16 0.74 t-0.72 0.3 l-0.16 0 q-0.44 0 -0.86 -0.3 t-0.5 -0.74 l-0.92 -5 l-6.6 0 z M139.27999999999997 38.92 q0 0.44 -0.34 0.74 t-0.82 0.3 l-3.48 0 q-0.44 0 -0.78 -0.3 t-0.34 -0.74 l0 -27.28 q0 -0.44 0.34 -0.76 t0.78 -0.32 l3.48 0 q0.4 0 0.72 0.24 t0.4 0.56 q1.8 5.32 3.5 10.42 t3.54 10.3 l0 -20.44 q0 -0.44 0.32 -0.76 t0.8 -0.32 l3.48 0 q0.44 0 0.78 0.32 t0.34 0.76 l0 27.28 q0 0.44 -0.34 0.74 t-0.78 0.3 l-3.28 0 q-1 0 -1.32 -1 q-1.76 -5.24 -3.48 -10.36 t-3.52 -10.28 l0 20.6 z M160.55999999999997 38.92 q0 0.44 -0.34 0.74 t-0.82 0.3 l-3.48 0 q-0.44 0 -0.78 -0.3 t-0.34 -0.74 l0 -27.28 q0 -0.44 0.34 -0.76 t0.78 -0.32 l3.48 0 q0.4 0 0.72 0.24 t0.4 0.56 q1.8 5.32 3.5 10.42 t3.54 10.3 l0 -20.44 q0 -0.44 0.32 -0.76 t0.8 -0.32 l3.48 0 q0.44 0 0.78 0.32 t0.34 0.76 l0 27.28 q0 0.44 -0.34 0.74 t-0.78 0.3 l-3.28 0 q-1 0 -1.32 -1 q-1.76 -5.24 -3.48 -10.36 t-3.52 -10.28 l0 20.6 z M188.27999999999997 10.600000000000001 q0.56 0 0.84 0.34 t0.28 0.72 t-0.28 0.72 t-0.84 0.34 l-6.44 0 l0 16.88 l4.24 0 q0.56 0 0.84 0.32 t0.28 0.72 t-0.28 0.72 t-0.84 0.32 l-4.24 0 l0 6.2 l5.92 0 q0.56 0 0.84 0.32 t0.28 0.72 t-0.28 0.72 t-0.84 0.32 l-10.56 0.04 q-0.44 0 -0.78 -0.3 t-0.34 -0.74 l0 -27.28 q0 -0.44 0.34 -0.76 t0.78 -0.32 l11.08 0 z M197.95999999999998 38.96 q0 0.44 -0.34 0.74 t-0.82 0.3 l-3.48 0 q-0.44 0 -0.78 -0.3 t-0.34 -0.74 l0 -27.28 q0 -0.44 0.34 -0.76 t0.78 -0.32 q2.04 0 4.1 0.02 t4.1 0.02 q1.64 0 3.08 0.58 t2.52 1.56 t1.7 2.32 t0.62 2.82 l0 4 q0 2.08 -1.16 3.8 t-3.04 2.64 q1.4 0.72 2.28 2.04 t0.88 2.92 l0 5.76 q0 0.36 -0.26 0.62 t-0.66 0.26 l-4.84 0 l0 -8.56 q0 -0.96 -0.46 -1.44 t-1.16 -0.66 t-1.52 -0.18 l-1.54 0 l0 9.84 z M197.95999999999998 12.36 l0 14.96 l2.8 0 q1.36 0 2.3 -0.88 t0.94 -2.12 l0 -8.96 q0 -1.24 -0.94 -2.12 t-2.3 -0.88 l-2.8 0 z">
                  </path>
                </g>
                <g id="SvgjsG4338" featurekey="sloganFeature-0"
                  transform="matrix(1.2635498237464111,0,0,1.2635498237464111,72.00000011297016,62.606436759129046)"
                  fill="url(#SvgjsLinearGradient4348)">
                  <path
                    d="M0 5.84 q0 -0.22 0.17 -0.37 t0.39 -0.15 l4.46 0 q0.86 0 1.63 0.31 t1.35 0.83 t0.91 1.23 t0.33 1.51 l0 6.92 q0 0.8 -0.33 1.5 t-0.91 1.23 t-1.35 0.84 t-1.63 0.31 l-4.46 0 q-0.22 0 -0.39 -0.15 t-0.17 -0.37 l0 -13.64 z M6.34 7.74 q0 -0.64 -0.5 -1.11 t-1.22 -0.47 l-1.74 0 l0 13 l1.74 0 q0.72 0 1.22 -0.47 t0.5 -1.13 l0 -9.82 z M13.52 19.48 q0 0.22 -0.17 0.37 t-0.41 0.15 l-1.74 0 q-0.22 0 -0.39 -0.15 t-0.17 -0.37 l0 -13.64 q0 -0.22 0.17 -0.38 t0.39 -0.16 q1.02 0 2.05 0.01 t2.05 0.01 q0.82 0 1.54 0.29 t1.26 0.78 t0.85 1.16 t0.31 1.41 l0 2 q0 1.04 -0.58 1.9 t-1.52 1.32 q0.7 0.36 1.14 1.02 t0.44 1.46 l0 2.88 q0 0.18 -0.13 0.31 t-0.33 0.13 l-2.42 0 l0 -4.28 q0 -0.48 -0.23 -0.72 t-0.58 -0.33 t-0.76 -0.09 l-0.77 0 l0 4.92 z M13.52 6.18 l0 7.48 l1.4 0 q0.68 0 1.15 -0.44 t0.47 -1.06 l0 -4.48 q0 -0.62 -0.47 -1.06 t-1.15 -0.44 l-1.4 0 z M26.759999999999998 5.300000000000001 q0.28 0 0.42 0.17 t0.14 0.36 t-0.14 0.36 t-0.42 0.17 l-3.22 0 l0 8.44 l2.12 0 q0.28 0 0.42 0.16 t0.14 0.36 t-0.14 0.36 t-0.42 0.16 l-2.12 0 l0 3.1 l2.96 0 q0.28 0 0.42 0.16 t0.14 0.36 t-0.14 0.36 t-0.42 0.16 l-5.28 0.02 q-0.22 0 -0.39 -0.15 t-0.17 -0.37 l0 -13.64 q0 -0.22 0.17 -0.38 t0.39 -0.16 l5.54 0 z M33.54 7.199999999999999 l-1.36 8.72 l2.96 0 z M31.619999999999997 19.48 q-0.04 0.22 -0.25 0.37 t-0.43 0.15 l-1.74 0 q-0.24 0 -0.37 -0.15 t-0.09 -0.37 l2.5 -13.64 q0.04 -0.22 0.25 -0.38 t0.43 -0.16 l2 0 q0.24 0 0.45 0.16 t0.25 0.38 l2.36 13.64 q0.04 0.22 -0.08 0.37 t-0.36 0.15 l-0.08 0 q-0.22 0 -0.43 -0.15 t-0.25 -0.37 l-0.46 -2.5 l-3.3 0 z M47.46 9.18 q-0.62 1.76 -1.22 3.53 t-1.2 3.55 q-0.06 0.22 -0.26 0.32 t-0.42 0.1 t-0.41 -0.1 t-0.27 -0.32 q-0.58 -1.8 -1.18 -3.55 t-1.22 -3.53 l0 10.3 q0 0.22 -0.17 0.37 t-0.41 0.15 l-1.74 0 q-0.22 0 -0.39 -0.15 t-0.17 -0.37 l0 -13.64 q0 -0.22 0.17 -0.38 t0.39 -0.16 l1.74 0 q0.2 0 0.36 0.12 t0.2 0.28 q0.78 2.36 1.55 4.63 t1.55 4.57 q0.8 -2.3 1.57 -4.57 t1.53 -4.63 l0.02 0 q0.04 -0.16 0.19 -0.28 t0.35 -0.12 l1.74 0 q0.24 0 0.41 0.16 t0.17 0.38 l0 13.64 q0 0.22 -0.17 0.37 t-0.41 0.15 l-1.74 0 q-0.22 0 -0.39 -0.15 t-0.17 -0.37 l0 -10.3 z M53.239999999999995 17 q0.64 0 1.07 0.43 t0.43 1.07 q0 0.62 -0.43 1.06 t-1.07 0.44 q-0.62 0 -1.06 -0.44 t-0.44 -1.06 q0 -0.64 0.44 -1.07 t1.06 -0.43 z M63.019999999999996 19.48 q0 0.22 -0.17 0.37 t-0.41 0.15 l-1.74 0 q-0.22 0 -0.39 -0.15 t-0.17 -0.37 l0 -13.64 q0 -0.22 0.17 -0.38 t0.39 -0.16 q1.02 0 2.05 0.01 t2.05 0.01 q0.82 0 1.54 0.29 t1.26 0.78 t0.85 1.16 t0.31 1.41 l0 1.94 q0 0.76 -0.31 1.43 t-0.85 1.16 t-1.26 0.78 t-1.54 0.29 l-1.78 0 l0 4.92 z M63.019999999999996 6.18 l0 7.54 l1.4 0 q0.68 0 1.15 -0.43 t0.47 -1.05 l0 -4.58 q0 -0.62 -0.47 -1.05 t-1.15 -0.43 l-1.4 0 z M73.03999999999999 18.94 l2.96 0 q0.28 0 0.42 0.16 t0.14 0.36 t-0.14 0.36 t-0.42 0.16 l-5.28 0.02 q-0.22 0 -0.39 -0.15 t-0.17 -0.37 l0 -13.64 q0 -0.22 0.17 -0.38 t0.39 -0.16 l1.74 0 q0.24 0 0.41 0.16 t0.17 0.38 l0 13.1 z M82.78 7.199999999999999 l-1.36 8.72 l2.96 0 z M80.86 19.48 q-0.04 0.22 -0.25 0.37 t-0.43 0.15 l-1.74 0 q-0.24 0 -0.37 -0.15 t-0.09 -0.37 l2.5 -13.64 q0.04 -0.22 0.25 -0.38 t0.43 -0.16 l2 0 q0.24 0 0.45 0.16 t0.25 0.38 l2.36 13.64 q0.04 0.22 -0.08 0.37 t-0.36 0.15 l-0.08 0 q-0.22 0 -0.43 -0.15 t-0.25 -0.37 l-0.46 -2.5 l-3.3 0 z M90.51999999999998 19.46 q0 0.22 -0.17 0.37 t-0.41 0.15 l-1.74 0 q-0.22 0 -0.39 -0.15 t-0.17 -0.37 l0 -13.64 q0 -0.22 0.17 -0.38 t0.39 -0.16 l1.74 0 q0.2 0 0.36 0.12 t0.2 0.28 q0.9 2.66 1.75 5.21 t1.77 5.15 l0 -10.22 q0 -0.22 0.16 -0.38 t0.4 -0.16 l1.74 0 q0.22 0 0.39 0.16 t0.17 0.38 l0 13.64 q0 0.22 -0.17 0.37 t-0.39 0.15 l-1.64 0 q-0.5 0 -0.66 -0.5 q-0.88 -2.62 -1.74 -5.18 t-1.76 -5.14 l0 10.3 z M99.77999999999999 17 q0.64 0 1.07 0.43 t0.43 1.07 q0 0.62 -0.43 1.06 t-1.07 0.44 q-0.62 0 -1.06 -0.44 t-0.44 -1.06 q0 -0.64 0.44 -1.07 t1.06 -0.43 z M106.67999999999999 5.84 q0 -0.22 0.17 -0.37 t0.39 -0.15 l4.46 0 q0.86 0 1.63 0.31 t1.35 0.83 t0.91 1.23 t0.33 1.51 l0 6.92 q0 0.8 -0.33 1.5 t-0.91 1.23 t-1.35 0.84 t-1.63 0.31 l-4.46 0 q-0.22 0 -0.39 -0.15 t-0.17 -0.37 l0 -13.64 z M113.02 7.74 q0 -0.64 -0.5 -1.11 t-1.22 -0.47 l-1.74 0 l0 13 l1.74 0 q0.72 0 1.22 -0.47 t0.5 -1.13 l0 -9.82 z M120.19999999999999 19.48 q0 0.22 -0.17 0.37 t-0.41 0.15 l-1.74 0 q-0.22 0 -0.39 -0.15 t-0.17 -0.37 l0 -13.64 q0 -0.22 0.17 -0.38 t0.39 -0.16 l1.74 0 q0.24 0 0.41 0.16 t0.17 0.38 l0 13.64 z M122.16 6.859999999999999 q0.52 -0.8 1.29 -1.23 t1.61 -0.53 t1.69 0.11 t1.52 0.69 t1.09 1.2 t0.42 1.62 q0.04 0.3 0.02 0.48 t-0.02 0.48 q0 0.22 -0.17 0.38 t-0.43 0.16 l-1.42 0 q-0.26 0 -0.44 -0.16 t-0.18 -0.38 l0 -1.9 q0 -0.68 -0.31 -1.08 t-0.73 -0.52 t-0.86 0.04 t-0.72 0.58 q-0.14 0.22 -0.21 0.54 t-0.09 0.68 q-0.08 1.1 0.31 1.79 t1 1.2 t1.35 0.93 t1.38 0.96 t1.08 1.3 t0.46 1.94 q0.02 0.7 -0.09 1.29 t-0.45 1.11 q-0.52 0.8 -1.29 1.23 t-1.61 0.53 t-1.69 -0.12 t-1.52 -0.69 t-1.09 -1.19 t-0.42 -1.64 q-0.04 -0.28 -0.02 -0.47 t0.02 -0.47 q0 -0.22 0.18 -0.38 t0.42 -0.16 l1.44 0 q0.24 0 0.42 0.16 t0.18 0.38 l0 1.9 q0 0.68 0.31 1.08 t0.73 0.52 t0.86 -0.04 t0.72 -0.58 q0.14 -0.22 0.21 -0.54 t0.11 -0.68 q0.06 -0.82 -0.15 -1.41 t-0.59 -1.04 t-0.88 -0.79 t-1.04 -0.68 t-1.05 -0.71 t-0.93 -0.85 t-0.68 -1.12 t-0.28 -1.52 q-0.02 -0.7 0.09 -1.29 t0.45 -1.11 z M139.84 9.52 q0 0.22 -0.17 0.38 t-0.41 0.16 l-1.34 0 q-0.24 0 -0.41 -0.16 t-0.17 -0.38 l0 -1.84 q0 -0.84 -0.49 -1.25 t-1.09 -0.39 t-1.09 0.44 t-0.49 1.26 l0 2.16 l0 5.6 l0 2.16 q0 0.84 0.49 1.26 t1.09 0.44 t1.09 -0.39 t0.49 -1.25 l0 -1.84 q0 -0.22 0.17 -0.38 t0.41 -0.16 l1.34 0 q0.24 0 0.41 0.16 t0.17 0.38 q0 0.28 0.01 0.46 t-0.03 0.46 q0 0.84 -0.35 1.5 t-0.94 1.12 t-1.34 0.69 t-1.54 0.21 t-1.55 -0.3 t-1.38 -0.87 t-1.02 -1.49 t-0.46 -2.16 l-0.02 -0.44 l0 -4.72 l0.02 -0.44 q0.08 -1.68 0.75 -2.73 t1.62 -1.57 t2.04 -0.53 t2.02 0.4 t1.54 1.21 t0.61 1.92 q0.04 0.28 0.03 0.46 t-0.01 0.46 z M144.07999999999998 17.7 q0 0.36 0.14 0.67 t0.38 0.54 t0.56 0.36 t0.68 0.13 t0.69 -0.13 t0.57 -0.36 t0.38 -0.54 t0.14 -0.67 l0 -10.08 q0 -0.7 -0.52 -1.19 t-1.26 -0.49 q-0.36 0 -0.68 0.13 t-0.56 0.36 t-0.38 0.54 t-0.14 0.65 l0 10.08 z M150.44 16.28 q0 0.84 -0.33 1.57 t-0.91 1.27 t-1.35 0.86 t-1.63 0.32 l-0.74 0 q-0.88 0 -1.64 -0.32 t-1.34 -0.86 t-0.91 -1.27 t-0.33 -1.57 l0 -7.18 q0 -0.84 0.33 -1.57 t0.91 -1.28 t1.34 -0.87 t1.64 -0.32 l0.74 0 q0.86 0 1.63 0.32 t1.35 0.87 t0.91 1.28 t0.33 1.57 l0 7.18 z M151.4 5.84 q-0.04 -0.22 0.09 -0.38 t0.37 -0.16 l1.74 0 q0.22 0 0.43 0.16 t0.25 0.38 l1.92 12.28 l2.24 -12.28 q0.04 -0.22 0.25 -0.38 t0.43 -0.16 l0.08 0 q0.24 0 0.36 0.16 t0.08 0.38 l-2.36 13.64 q-0.04 0.22 -0.25 0.37 t-0.45 0.15 l-2 0 q-0.22 0 -0.43 -0.15 t-0.25 -0.37 z M167.16 5.300000000000001 q0.28 0 0.42 0.17 t0.14 0.36 t-0.14 0.36 t-0.42 0.17 l-3.22 0 l0 8.44 l2.12 0 q0.28 0 0.42 0.16 t0.14 0.36 t-0.14 0.36 t-0.42 0.16 l-2.12 0 l0 3.1 l2.96 0 q0.28 0 0.42 0.16 t0.14 0.36 t-0.14 0.36 t-0.42 0.16 l-5.28 0.02 q-0.22 0 -0.39 -0.15 t-0.17 -0.37 l0 -13.64 q0 -0.22 0.17 -0.38 t0.39 -0.16 l5.54 0 z M172 19.48 q0 0.22 -0.17 0.37 t-0.41 0.15 l-1.74 0 q-0.22 0 -0.39 -0.15 t-0.17 -0.37 l0 -13.64 q0 -0.22 0.17 -0.38 t0.39 -0.16 q1.02 0 2.05 0.01 t2.05 0.01 q0.82 0 1.54 0.29 t1.26 0.78 t0.85 1.16 t0.31 1.41 l0 2 q0 1.04 -0.58 1.9 t-1.52 1.32 q0.7 0.36 1.14 1.02 t0.44 1.46 l0 2.88 q0 0.18 -0.13 0.31 t-0.33 0.13 l-2.42 0 l0 -4.28 q0 -0.48 -0.23 -0.72 t-0.58 -0.33 t-0.76 -0.09 l-0.77 0 l0 4.92 z M172 6.18 l0 7.48 l1.4 0 q0.68 0 1.15 -0.44 t0.47 -1.06 l0 -4.48 q0 -0.62 -0.47 -1.06 t-1.15 -0.44 l-1.4 0 z">
                  </path>
                </g>
              </svg> -->
              <!--                <ig-powered-by [style]="'iti-horizontal'"></ig-powered-by>-->


              <div class="flex">
                <ig-social-login [mode]="isMobile ? 'popup' : 'horizontal'"
                  (onLoginStatusChanged)="loginStatusChanged($event)"></ig-social-login>
              </div>
            </div>
          </div>

          @if (displayingOn === 'event') {
          <div class="flex h-[calc(100%-80px)] rounded-br-3xl mobile:h-[calc(100%-68px)]">
            <div class="w-[55%] h-full px-8 bg-[#f3f6fc] relative mobile:w-full" [class.w-[50%]]="is2xl"
              [class.w-[50%]]="is2xl && frontendSettings.customSettings.tripPlanner.desktopPage.listColumns < 4"
              [class.w-[60%]]="is2xl && frontendSettings.customSettings.tripPlanner.desktopPage.listColumns === 4"
              [class.!w-[45%]]="is3xl && frontendSettings.customSettings.tripPlanner.desktopPage.listColumns < 4"
              [class.!w-[60%]]="is3xl && frontendSettings.customSettings.tripPlanner.desktopPage.listColumns === 4"
              [class.!w-[40%]]="is4xl && frontendSettings.customSettings.tripPlanner.desktopPage.listColumns < 4"
              [class.!w-[60%]]="is4xl && frontendSettings.customSettings.tripPlanner.desktopPage.listColumns === 4"
              [class.!w-[65%]]="frontendSettings.customSettings.tripPlanner.desktopPage.listColumns === 4 && (isLg || isXl)">
              <div class="flex justify-between gap-2 pl-0.5 pt-6 px-0.5 mobile:pt-1">
                <ig-event-date-filter mode="dropdown" menuClass="ig-date-filter"
                  (dateSelected)="filterEventsByDate($event)"></ig-event-date-filter>
              </div>
              <div class="mt-3 px-0.5 mobile:mt-1">
                <ig-favorite-custom-event-filter mode="dropdown"
                  (favSelected)="favCustomEventSelected($event)"></ig-favorite-custom-event-filter>
              </div>
              <div class="mt-3 px-0.5">
                <ig-search-field label="search events" [formControl]="eventSearchControl"
                  outline="plain"></ig-search-field>
              </div>

              <div *ngIf="events.length && !isLoadingItems"
                class="w-full bottom-4 left-0 flex justify-end items-center gap-2 z-10 text-gray-500 text-sm my-2.5">
                <p *ngIf="events.length > 1">
                  Events: {{ (eventPage - 1) * pageSize + 1 }} -
                  {{
                  events.length >= pageSize
                  ? eventPage * pageSize
                  : (eventPage - 1) * pageSize + events.length
                  }}
                </p>
                <mat-icon class="p-1 rounded-md bg-blue-400 text-white cursor-pointer leading-4"
                  [class.bg-gray-200]="eventPage === 1" [class.cursor-not-allowed]="eventPage === 1"
                  (click)="prevPageEvents()">
                  chevron_left
                </mat-icon>
                <mat-icon class="p-1 rounded-md bg-blue-400 text-white cursor-pointer leading-4"
                  [class.bg-gray-200]="events.length < pageSize" [class.cursor-not-allowed]="events.length < pageSize"
                  (click)="nextPageEvents()">
                  chevron_right
                </mat-icon>
              </div>

              <div class="overflow-y-auto h-[calc(100%-226px)] mt-3 mobile:h-[calc(100%-200px)]">
                @if (isLoadingItems) {
                <div class="flex h-[90%] justify-center items-center">
                  <ig-spinner></ig-spinner>
                </div>
                } @else { @if (events.length) {

                <div class="grid gap-3 p-0.5 overflow-y-scroll h-auto cursor-pointer ig-tp-card-container mobile:grid-cols-2 grid-cols-{{
                  frontendSettings.customSettings.tripPlanner.desktopPage.listColumns}}">
                  @for (event of events; let i = $index; track i) {
                  <div class="flex flex-col justify-between rounded-lg bg-white p-4 text-gray-500 shadow h-full "
                    [style]="{'padding': frontendSettings.customSettings.tripPlanner.desktopPage.listMargin + 'px'}">
                    <div (click)="isMobile ? showMobileMap(event) : clickAttraction(event)"
                      class="relative flex gap-2 flex-col aspect-auto ig-tp-card"
                      [class.ig-tp-card-mobile]="event.isChoice && isMobile">
                      <div class="w-full relative min-w-[unset] max-w-[unset]">
                        <ig-image [src]="event.cover?.source"
                          [class.ig-tp-only-border-top]="!frontendSettings.customSettings.tripPlanner.desktopPage.listMargin"
                          cls="aspect-7-4 rounded-lg"></ig-image>
                        <div igClickStopPropagation
                          class="absolute bottom-0 left-0 w-full bg-transparent text-white text-center cursor-pointer text-xs rounded-sm hidden xl:block">
                          <!-- <ig-add-to-trip *ngIf="trips" [item]="event" [showItemType]="false" [userTrips]="trips"
                            [highlightBorderTop]="true" [forTripPlannerV3]="true" igClickStopPropagation
                            class="block mobile:mt-2"></ig-add-to-trip> -->
                        </div>
                      </div>

                      <p *ngIf="event.isChoice"
                        class="w-full py-1 absolute top-0 left-0 z-[1] inline-block bg-gradient-to-b from-[#b04aeacf] to-[#773bf29e] text-xs text-white text-center rounded-t-lg">
                        <span>{{frontendSettings?.customSettings.customEditorChoice.editorChoiceForEvent}}</span>
                      </p>
                      <!-- <mat-icon (click)="showMobileMap(event)" igClickStopPropagation
                        [class.!top-[48px]]="event.isChoice"
                        class="absolute left-2 top-2 rounded-full bg-white flex items-center justify-center text-center leading-6 !w-6 !h-6 !hidden mobile:!block">
                        room
                      </mat-icon> -->

                      <div class="flex flex-col justify-between w-full"
                        [style]="{'padding': frontendSettings.customSettings.tripPlanner.desktopPage.listMargin ? '0px' : '0 8px'}">
                        <div>
                          <b class="max-lines-2 text-xs mb-1 block 1200:text-[12px] 3xl:text-md">{{
                            event.name
                            }}</b>
                          <p class="text-[11px] mb-2" [class.max-lines-1]="is3xl">
                            {{ event.timeOneLine }}
                            <mat-icon *ngIf="event['isExpired']" class="!w-4 !h-4 text-[16px]"
                              matTooltip="This event is expired">info</mat-icon>
                          </p>
                          <!-- <p class="text-xs max-lines-2">
                            {{ event.address.address }}
                          </p> -->
                        </div>
                      </div>
                    </div>
                    <div
                      [style]="{'padding': frontendSettings.customSettings.tripPlanner.desktopPage.listMargin ? '0px' : '8px'}"
                      class="flex items-center justify-center w-full text-[11px] text-white font-semibold">
                      <div (click)="showDetails(event)"
                        class="bg-blue-400 rounded-l-sm h-[21px] leading-[14px] py-1 w-full text-center text-white border-r-[1px]">
                        DETAILS
                      </div>
                      <ig-add-to-trip *ngIf="trips" [item]="event" [showItemType]="false" [userTrips]="trips"
                        [forTripPlannerV3]="true" [mode]="'half'" (loginChanged)="addToTripLoginChanged($event)"
                        class="w-full"></ig-add-to-trip>
                    </div>
                  </div>
                  }
                </div>
                } @else {
                <div class="flex flex-col items-center justify-center h-[80%]">
                  <img [src]="
                      'https://pic.rmb.bdstatic.com/bjh/user/d0283ed699ccb053bbce0789865cd9b5.jpeg'
                    " alt="" class="w-[100px] rounded-full" />
                  <p class="mt-4 text-gray-400">Oops! No events found.</p>
                </div>
                } }
              </div>

            </div>

            <div *ngIf="!isMobile || (isMobile && isShowingMapOnMobile)"
              class="flex-grow h-full rounded-br-3xl top-[68px] left-0 mobile:z-10 mobile:absolute mobile:w-full mobile:h-[calc(100%-68px)]">
              <ig-google-map class="h-full w-full rounded-br-3xl" [markers]="mapMarkers"
                [useCluster]="useMapMarkerCluster" [useDefaultMarkerClickStyle]="false"
                (onMarkerClick)="markerClick($event, 'event')" (onDetailsWindowClose)="onDetailsWindowClose($event)"
                (onInfoWindowClick)="infoWindowClick($event)"></ig-google-map>
            </div>
          </div>
          } @if (displayingOn === 'place') {
          <div class="flex h-[calc(100%-6vh)] rounded-br-3xl mobile:h-[calc(100%-68px)]">
            <div class="w-[55%] h-full px-8 bg-[#f3f6fc] relative mobile:w-full"
              [class.w-[50%]]="is2xl && frontendSettings.customSettings.tripPlanner.desktopPage.listColumns < 4"
              [class.w-[60%]]="is2xl && frontendSettings.customSettings.tripPlanner.desktopPage.listColumns === 4"
              [class.!w-[45%]]="is3xl && frontendSettings.customSettings.tripPlanner.desktopPage.listColumns < 4"
              [class.!w-[60%]]="is3xl && frontendSettings.customSettings.tripPlanner.desktopPage.listColumns === 4"
              [class.!w-[40%]]="is4xl && frontendSettings.customSettings.tripPlanner.desktopPage.listColumns < 4"
              [class.!w-[60%]]="is4xl && frontendSettings.customSettings.tripPlanner.desktopPage.listColumns === 4"
              [class.!w-[65%]]="frontendSettings.customSettings.tripPlanner.desktopPage.listColumns === 4 && (isLg || isXl)">
              <div class="flex justify-between gap-2 pl-0.5 pt-6 mobile:pt-1">
                <ig-custom-default-place-category-filter class="w-[calc(100%-3px)]"
                  [isTriggerCalendarReload]="false"></ig-custom-default-place-category-filter>
              </div>
              <div class="mt-3 px-0.5 relative">
                <ig-search-field label="search places" [formControl]="placeSearchControl"
                  outline="plain"></ig-search-field>
              </div>

              <div *ngIf="places.length && !isLoadingItems"
                class="w-full flex justify-end items-center gap-2 mt-3 text-gray-500 text-sm">
                <p *ngIf="places.length > 1">
                  Places: {{ (placePage - 1) * pageSize + 1 }} -
                  {{
                  places.length >= pageSize
                  ? placePage * pageSize
                  : (placePage - 1) * pageSize + places.length
                  }}
                </p>
                <mat-icon class="p-1 rounded-md bg-blue-400 text-white cursor-pointer leading-4"
                  [class.bg-gray-200]="placePage === 1" [class.cursor-not-allowed]="placePage === 1"
                  (click)="prevPagePlaces()">
                  chevron_left
                </mat-icon>
                <mat-icon class="p-1 rounded-md bg-blue-400 text-white cursor-pointer leading-4"
                  [class.bg-gray-200]="places.length < pageSize" [class.cursor-not-allowed]="places.length < pageSize"
                  (click)="nextPagePlaces()">
                  chevron_right
                </mat-icon>
              </div>

              <div class="overflow-y-auto h-[calc(100%-177px)] mt-3 mobile:h-[calc(100%-158px)]">
                @if (isLoadingItems) {
                <div class="flex h-[90%] justify-center items-center">
                  <ig-spinner></ig-spinner>
                </div>
                } @else { @if (places.length) {
                <div class="grid gap-3 p-0.5 h-auto cursor-pointer ig-tp-card-container mobile:grid-cols-2 grid-cols-{{
                  frontendSettings.customSettings.tripPlanner.desktopPage.listColumns}}">
                  @for (place of places; let i = $index; track i) {
                  <div class="flex flex-col justify-between rounded-lg bg-white p-4 text-gray-500 shadow h-full"
                    [style]="{'padding': frontendSettings.customSettings.tripPlanner.desktopPage.listMargin + 'px'}">
                    <div (click)="isMobile ? showMobileMap(place) : clickAttraction(place)"
                      class="relative flex gap-2 flex-col aspect-auto mobile:aspect-auto ig-tp-card"
                      [class.ig-tp-card-mobile]="place.isChoice && isMobile">
                      <div class="relative w-full min-w-[unset] max-w-[unset]">
                        <ig-image [src]="place.cover?.source"
                          [class.ig-tp-only-border-top]="!frontendSettings.customSettings.tripPlanner.desktopPage.listMargin"
                          cls="aspect-7-4 rounded-lg"></ig-image>

                        <p *ngIf="place.rating"
                          class="absolute right-2 bottom-2 flex items-center gap-0 bg-gray-50 rounded-3xl h-4.5 px-1.5">
                          <mat-icon class="text-xs !w-3.5 !h-4 text-[gold]">star</mat-icon>
                          <span class="text-xs">{{ place.rating }}</span>
                        </p>
                      </div>

                      <p *ngIf="place.isChoice"
                        class="w-full py-1 absolute top-0 left-0 z-[1] inline-block bg-gradient-to-b from-[#b04aeacf] to-[#773bf29e] text-xs text-white text-center rounded-t-lg">
                        <span>{{frontendSettings?.customSettings.customEditorChoice.editorChoiceForPlace}}</span>
                      </p>
                      <!-- <mat-icon (click)="showMobileMap(place)" igClickStopPropagation
                        [class.!top-[48px]]="place.isChoice"
                        class="absolute left-2 top-2 rounded-full bg-white flex items-center justify-center text-center leading-6 !w-6 !h-6 !hidden mobile:!block">
                        room
                      </mat-icon> -->

                      <div class="flex flex-col justify-between w-full"
                        [style]="{'padding': frontendSettings.customSettings.tripPlanner.desktopPage.listMargin ? '0px' : '0 8px'}">
                        <div>
                          <b class="max-lines-2 text-xs block mb-1 1200:text-[12px] 3xl:text-md">{{ place.name }}
                            <!-- <mat-icon class="text-xs !w-3.5 !h-4 text-[gold] leading-5 hidden mobile:inline">
                              star
                            </mat-icon>
                            <span class="text-xs mobile:inline">{{
                              place.rating
                              }}</span> -->
                          </b>
                          <!-- <p class="text-xs max-lines-2" [class.max-lines-1]="is3xl">
                            {{ place.categoryText }}
                          </p> -->
                          <!-- <p class="text-xs max-lines-2 mb-1">
                            {{ place.address.address }}
                          </p> -->
                        </div>
                      </div>

                    </div>
                    <div
                      [style]="{'padding': frontendSettings.customSettings.tripPlanner.desktopPage.listMargin ? '0px' : '8px'}"
                      class="flex items-center justify-center w-full text-[11px] text-white font-semibold">
                      <div (click)="showDetails(place)"
                        class="bg-blue-400 rounded-l-sm h-[21px] leading-[14px] py-1 w-full text-center text-white border-r-[1px]">
                        DETAILS
                      </div>
                      <ig-add-to-trip *ngIf="trips" [item]="place" [showItemType]="false" [userTrips]="trips"
                        [forTripPlannerV3]="true" [mode]="'half'" (loginChanged)="addToTripLoginChanged($event)"
                        (onAddTrip)="loadTrips($event)" class="w-full"></ig-add-to-trip>
                    </div>
                  </div>
                  }
                </div>
                } @else {
                <div class="flex flex-col items-center justify-center h-[80%]">
                  <img [src]="
                      'https://pic.rmb.bdstatic.com/bjh/user/d0283ed699ccb053bbce0789865cd9b5.jpeg'
                    " alt="" class="w-[100px] rounded-full" />
                  <p class="mt-4 text-gray-400">Oops! No places found.</p>
                </div>
                } }
              </div>
            </div>

            <div *ngIf="!isMobile || (isMobile && isShowingMapOnMobile)"
              class="flex-grow h-full rounded-br-3xl top-[68px] left-0 mobile:z-10 mobile:absolute mobile:w-full mobile:h-[calc(100%-68px)]">

              <ig-google-map class="h-full w-full rounded-br-3xl" [markers]="mapMarkers"
                [useCluster]="useMapMarkerCluster" [useDefaultMarkerClickStyle]="false"
                (onMarkerClick)="markerClick($event, 'place')" (onCloseInfoWindow)="onCloseInfoWindow()"
                (onInfoWindowClick)="infoWindowClick($event)"
                (onDetailsWindowClose)="onDetailsWindowClose($event)"></ig-google-map>

            </div>
          </div>
          } @if (displayingOn === 'itinerary') {
          <div class="block h-[calc(100%-80px)] overflow-y-auto">
            <ig-itinerary [isFromTripPlanner]="true" class="block pb-8 min-h-[70vh]"></ig-itinerary>
          </div>
          } @if (displayingOn === 'trip') {
          <div class="w-full absolute left-0 top-4 flex items-center justify-center">
            <ig-confirm-dialog *ngIf="isShowUnSavedChangesConfirm" class="!relative !w-[400px]"
              (confirm)="forceQuitTrip()" (cancel)="isShowUnSavedChangesConfirm = false" igClickStopPropagation
              text="There are unsaved changes. Do you want to discard them?">
            </ig-confirm-dialog>
          </div>

          <div #tripSection class="flex h-[calc(100%-80px)] rounded-br-3xl">
            <div class="w-[40%] h-full bg-[#f3f6fc] mobile:w-full" [class.relative]="!isLoadingTrips"
              (click)="isMobile && (isSidebarOpen = false)">
              <div class="flex flex-col gap-0 h-full relative" [class.!h-0]="isAIThinking">
                @if (isLoadingTrips || isDeletingTrip) {
                <!--                      isAIThinking means it is loaded from mobile view, clicking on the AI suggested itineraries directly, which will jump to My Trips view and waiting for AI suggestion-->
                <div *ngIf="!isAIThinking" class="absolute flex w-full h-[80%] items-center justify-center">
                  <ig-spinner></ig-spinner>
                </div>
                } @else { @if (!trips || !trips.length) {
                <div class="px-8 flex flex-col gap-0 h-[calc(100%-1.5rem)]">
                  <ig-image [src]="defaultTripImg" cls="aspect-7-4 w-full rounded-t-lg mt-6 max-h-[17vh]"></ig-image>
                  <div class="bg-white flex-grow rounded-b-lg pb-8">
                    <div class="flex flex-col items-center pt-[5vh] gap-5 h-full px-[10%]">
                      <ig-image [src]="
                          'https://pic.rmb.bdstatic.com/bjh/user/d0283ed699ccb053bbce0789865cd9b5.jpeg'
                        " cls="w-20 h-20"></ig-image>

                      <p #noTripTip class="text-gray-400 text-center text-[15px]">
                        <!-- You haven't created your trip yet, please create your
                        first trip and start building your itinerary. -->

                        Welcome to the Trip Planner! This page allows you to create trips in awesome ways. If you need
                        ideas, feel free to use our AI-Powered Trip Creator to get personalized suggestions based on
                        your interests. Prefer to plan every detail yourself? Simply hit the Create A Trip button to
                        manually add your favorite places and events. Whether you're spontaneous or a meticulous
                        planner, we've got you covered!
                      </p>
                      <div #createTripBtn class="flex flex-col items-center gap-2 w-full">
                        <div
                          class="w-full bg-[#41abf3] py-2 text-white rounded-[4px] uppercase text-center text-sm cursor-pointer transition-all hover:shadow-lg"
                          (click)="createTrip()" matRipple [matRippleCentered]="true"
                          [matRippleColor]="'rgba(255, 255, 255, 0.1)'">Create a trip
                        </div>
                        <div
                          class="w-full bg-[#41abf3] py-2 text-white rounded-[4px] uppercase text-center text-sm cursor-pointer transition-all hover:shadow-lg"
                          #aiTripMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="aiTripMenu" matRipple
                          [matRippleCentered]="true" [matRippleColor]="'rgba(255, 255, 255, 0.1)'">Get AI-Powered
                          Suggestions
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                } @else {
                <div class="text-gray-500 overflow-y-auto relative flex-grow h-[calc(100%-200px)]"
                  [class.max-h-0]="isAIThinking">
                  @if (!currentTrip) {
                  <div *ngIf="!isAIThinking" class=" w-full flex flex-col gap-2 p-8 justify-center">
                    <!-- <ig-button mode="flat" cls="w-[160px]" (trigger)="createTrip()">Create a trip
                      </ig-button> -->

                    <p #noTripTip class="text-gray-400 text-center text-sm">
                      Welcome to the Trip Planner! This page allows you to create trips in awesome ways. If you need
                      ideas, feel free to use our AI-Powered Trip Creator to get personalized suggestions based on
                      your interests. Prefer to plan every detail yourself? Simply hit the Create A Trip button to
                      manually add your favorite places and events. Whether you're spontaneous or a meticulous
                      planner, we've got you covered!
                    </p>
                    <div #createTripBtn class="flex flex-col items-center gap-2 w-full">
                      <div
                        class="w-full bg-[#41abf3] py-2 text-white rounded-[4px] uppercase text-center text-sm cursor-pointer transition-all hover:shadow-lg"
                        (click)="createTrip()" matRipple [matRippleCentered]="true"
                        [matRippleColor]="'rgba(255, 255, 255, 0.1)'">Create a trip
                      </div>
                      <div
                        class="w-full bg-[#41abf3] py-2 text-white rounded-[4px] uppercase text-center text-sm cursor-pointer transition-all hover:shadow-lg"
                        #aiTripMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="aiTripMenu" matRipple
                        [matRippleCentered]="true" [matRippleColor]="'rgba(255, 255, 255, 0.1)'">Get AI-Powered
                        Suggestions
                      </div>

                    </div>
                  </div>

                  <div class="overflow-y-auto pb-24 flex flex-col gap-6 relative" [class.!h-0]="isAIThinking"
                    [class.!pb-0]="isAIThinking" [class.!overflow-hidden]="isAIThinking">

                    @for (trip of trips; let i = $index; track i) {
                    <div #userTrips
                      class="bg-white rounded-2xl mx-8 flex gap-0 cursor-pointer relative transition-all outline-[#41abf3] group hover:shadow-md"
                      (click)="enterTrip(trip)">
                      <ig-image [src]="
                          trip.img ||
                          trip.days[0]?.attractions[0]?.item?.cover?.source ||
                          defaultTripImg
                        " class="min-w-[30%] max-w-[30%]" cls="w-full aspect-square rounded-l-2xl"></ig-image>

                      <div class="p-3">
                        <p class="font-semibold">{{ trip.title }}</p>
                        <p class="text-sm">
                          {{ trip.days.length }} day{{
                          trip.days.length > 1 ? "s" : ""
                          }}
                          , {{ getTotalStops(trip).text }}
                        </p>
                      </div>

                      <div *ngIf="trip.status !== 'cloud' && SocialLoginComponent.isUserLoggedIn" igClickStopPropagation
                        matTooltip="This trip was created before logging in. Click to save this trip to your account"
                        class="absolute inline-flex gap-2 right-2 bottom-2 z-[10] bg-transparent transition-all duration-150 items-center">
                        <p *ngIf="trip.status === 'local'" class="text-xs" (click)="saveTripToDB(trip)">
                          <mat-icon class="!w-4 !h-4 text-[16px] leading-[22px]">upload</mat-icon>Save
                        </p>
                        <p *ngIf="trip.status === 'syncing'" class="text-xs flex items-center gap-1">
                          <mat-icon class="!w-4 !h-4 text-[16px] leading-[16px] ig-spin">autorenew</mat-icon>Saving
                        </p>

                        <div *ngIf="trip.status === 'synced'" class="flex items-center gap-1">
                          <ig-success-checkmark [width]="20"></ig-success-checkmark>
                          <span class="text-xs">Saved!</span>
                        </div>
                      </div>

                      <div igClickStopPropagation (click)="isShowDeleteTripConfirms[i] = true;cdRef.detectChanges()"
                        class="absolute inline-flex gap-2 right-2 top-2 z-[10] bg-transparent opacity-0 transition-all duration-150 group-hover:opacity-100 mobile:opacity-100">
                        <mat-icon class="!w-6 !h-6 text-[24px] leading-6 cursor-pointer text-red-400">
                          delete_forever
                        </mat-icon>
                      </div>
                      <ig-confirm-dialog *ngIf="isShowDeleteTripConfirms[i]" class="!w-[300px] right-2 top-2"
                        (confirm)="deleteTrip(trip)" (cancel)="closeConfirms()" igClickStopPropagation
                        text="Are you sure you want to remove this trip?">
                      </ig-confirm-dialog>
                    </div>
                    }

                    <!-- <ig-confirm-dialog *ngIf="saveTripToDBText"
                      class="!w-[300px] bottom-[10vh] absolute left-[calc(50%-150px)]" (confirm)="saveTripToDB()"
                      (cancel)="closeConfirms()" igClickStopPropagation [text]="saveTripToDBText">
                    </ig-confirm-dialog> -->
                  </div>

                  <!-- <div *ngIf="!isAIThinking" class="absolute w-full bottom-12 left-0 flex justify-center z-10">
                    <ig-button mode="flat" cls="w-[160px]" (trigger)="createTrip()">Create a trip
                    </ig-button>
                  </div> -->
                  } @else {
                  <div class="h-full pt-6">
                    <div class="h-full flex flex-col">
                      <div #tripTitle class="px-8 relative transition-all duration-150 ig-tp-flex-item">
                        <div class="flex items-start justify-between gap-6">
                          <div>
                            <div class="relative flex gap-2 items-start">
                              <mat-icon class="cursor-pointer leading-6" (click)="backToTripList()">west
                              </mat-icon>
                              <b class="font-semibold text-[20px]">{{
                                currentTrip.title
                                }}</b>
                              <span *ngIf="isEditMode"
                                class="bg-blue-900 rounded-full !w-6 !h-6 min-w-[24px] flex justify-center items-center"
                                #editTitleMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="editTitleMenu">
                                <mat-icon class="text-[12px] !w-3 !h-[15px] text-white cursor-pointer">
                                  border_color
                                </mat-icon>
                                <mat-menu #editTitleMenu="matMenu" class="ig-text-color-edit !rounded-md px-6 py-2">
                                  <div igClickStopPropagation (keydown)="onKeyDown($event)">
                                    <p class="text-lg font-semibold text-gray-600 !mb-3">
                                      Edit Trip Title
                                    </p>

                                    <ig-field [control]="titleForm.get('title')" label="Title" icon="title"
                                      igClickStopPropagation></ig-field>

                                    <ig-button class="" cls="w-[80px]" (trigger)="
                                        setTripTitle(editTitleMenuTrigger)
                                      ">
                                      OK
                                    </ig-button>
                                  </div>
                                </mat-menu>
                              </span>
                            </div>
                            <p *ngIf="currentTrip.days.length === 1" class="text-sm mt-2 mb-2 mobile:text-[12px]">
                              {{ currentTrip.days[0].dateText }}
                            </p>
                            <p *ngIf="currentTrip.days.length > 1" class="text-sm mt-2 mb-2 mobile:text-[12px]">
                              {{ currentTrip.days[0].dateText }} -
                              {{ currentTrip.days.last().dateText }} ({{
                              currentTrip.days.length
                              }}
                              day{{ currentTrip.days.length > 1 ? "s" : "" }})
                            </p>
                          </div>
                          <div>
                            <div class="flex items-center gap-3">
                              <ig-button class="" mode="flat" (trigger)="editOrSave($event)" [isAsync]="isEditMode"
                                [successTextDisplayTime]="3000" successText="Saved!">{{ isEditMode ? "save" : "edit" }}
                              </ig-button>
                              <span *ngIf="isEditMode" class="underline cursor-pointer text-sm text-gray-400"
                                (click)="cancelEdit()">Cancel</span>
                            </div>

                            <!--                                      <span-->
                            <!--                                        class="flex items-center w-fit text-gray-500 gap-3 cursor-pointer">-->
                            <!--                                                                        <mat-slide-toggle color="primary"-->
                            <!--                                                                                          [(ngModel)]="isShowPlans"-->
                            <!--                                                                                          class="">Show plans</mat-slide-toggle>-->
                            <!--                                                                      </span>-->
                          </div>
                        </div>
                      </div>
                      <div #tripContainer [class.select-none]="isDragging"
                        class="ig-tp-trip-details-container ig-tp-flex-item overflow-y-auto h-full relative">
                        <div *ngIf="isEditMode" class="flex gap-3 px-8 mt-1 justify-between items-center">
                          <!--                                                                      <span-->
                          <!--                                                                        class="flex items-center w-fit text-gray-500 gap-3 cursor-pointer">-->
                          <!--                                                                        <mat-slide-toggle color="primary"-->
                          <!--                                                                                          [(ngModel)]="isShowPlans"-->
                          <!--                                                                                          class="">Show plans</mat-slide-toggle>-->
                          <!--                                                                      </span>-->

                          <div>
                            <input matInput [matDatepicker]="picker" [(ngModel)]="newDay"
                              [matDatepickerFilter]="dateFilter" class="w-0 h-0 opacity-0 absolute"
                              (dateChange)="addDay()" />

                            <span (click)="picker.open()"
                              class="flex items-center w-fit rounded-full bg-white py-1 px-3 text-gray-500 gap-3 border border-dashed border-gray-300 cursor-pointer">
                              <mat-icon class="!w-4 !h-4 text-[16px]">scheduler</mat-icon>
                              <span class="text-xs">Add a day</span>
                            </span>
                            <mat-datepicker #picker></mat-datepicker>
                          </div>
                        </div>

                        @if (!currentTrip.days.length) {
                        <p
                          class="mt-20 text-gray-400 px-10 text-[16px] leading-6 text-center flex flex-col items-center gap-4">
                          <ig-image [src]="
                              'https://pic.rmb.bdstatic.com/bjh/user/d0283ed699ccb053bbce0789865cd9b5.jpeg'
                            " cls="!w-20 !h-20 rounded-full"></ig-image>
                          You haven't added any days, events or places to visit
                          to this trip yet. You can start by adding a day and go
                          to Events or Places and start building your itinerary.
                        </p>
                        }

                        <mat-tab-group #daysTabGroup class="h-full relative" (selectedIndexChange)="switchDays($event)">
                          @for (day of currentTrip?.days; let dayIndex = $index;
                          track dayIndex) {

                          <mat-tab [label]="day.dateText" class="cursor-pointer relative">
                            <div *ngIf="!isEditMode" igClickStopPropagation igOutsideClick
                              (outsideClick)="isShowTripFunctions = false"
                              class="absolute z-50 bottom-5 right-5 rounded-full w-16 h-16 bg-white cursor-pointer shadow-lg text-center ig-tp-trip-func"
                              (click)="
                                !pdfProgress &&
                                  (isShowTripFunctions = !isShowTripFunctions)
                              ">
                              <div class="relative">
                                <mat-icon *ngIf="!pdfProgress"
                                  class="!text-[32px] !leading-[64px] z-30 absolute left-2 top-0">
                                  {{ isShowTripFunctions ? "expand_more" : "menu" }}
                                </mat-icon>
                                <ig-loading-dot *ngIf="pdfProgress" matTooltip="Generating PDF..."
                                  class="relative z-[31] scale-[0.65] block translate-y-4 translate-x-0.5">
                                </ig-loading-dot>
                                <mat-progress-spinner *ngIf="pdfProgress" mode="determinate" [strokeWidth]="3"
                                  [diameter]="64" [value]="pdfProgress"
                                  class="-translate-y-[50px]"></mat-progress-spinner>

                                <mat-icon matTooltip="Share this trip" matTooltipPosition="left"
                                  class="opacity-0 hidden transition-all duration-150 z-10 absolute left-2 top-0 shadow-lg"
                                  (click)="shareTrip()" [class.opacity-100]="isShowTripFunctions"
                                  [class.translate-y-[-62px]]="
                                    isShowTripFunctions
                                  " [class.block]="isShowTripFunctions">share
                                </mat-icon>

                                <mat-icon [matTooltip]="pdfProgress ? '' : 'Export to PDF'" matTooltipPosition="left"
                                  class="opacity-0 hidden transition-all duration-150 z-10 absolute left-2 top-0 shadow-lg"
                                  (click)="exportPDF()" [class.opacity-100]="isShowTripFunctions"
                                  [class.translate-y-[-122px]]="
                                    isShowTripFunctions
                                  " [class.block]="isShowTripFunctions">picture_as_pdf
                                </mat-icon>

                                <mat-icon matTooltip="Change travel mode" matTooltipPosition="left"
                                  class="opacity-0 hidden transition-all duration-150 z-10 absolute left-2 top-0 shadow-lg"
                                  [class.opacity-100]="isShowTripFunctions" igClickStopPropagation
                                  [class.translate-y-[-182px]]="isShowTripFunctions" [class.block]="isShowTripFunctions"
                                  #travelModeMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="travelModeMenu">{{
                                  currentTrip.travelMode === 'DRIVING' ? 'directions_car' : currentTrip.travelMode ===
                                  'BICYCLING' ? 'directions_bike' : 'directions_walk'}}
                                </mat-icon>
                                <mat-menu #travelModeMenu="matMenu" class="ig-iti-details-style-menu">
                                  <div class="pb-2 pr-5 pl-4">
                                    <mat-radio-group class="flex flex-col" aria-label="Select an option"
                                      [(ngModel)]="currentTrip.travelMode" (change)="travelMode(travelModeMenuTrigger)"
                                      igClickStopPropagation>
                                      <mat-radio-button value="DRIVING">DRIVING</mat-radio-button>
                                      <mat-radio-button value="BICYCLING" class="">CYCLING</mat-radio-button>
                                      <mat-radio-button value="WALKING" class="">WALKING</mat-radio-button>
                                    </mat-radio-group>
                                  </div>
                                </mat-menu>

                                <mat-icon matTooltip="GPS directions" matTooltipPosition="left"
                                  class="opacity-0 hidden transition-all duration-150 z-10 absolute left-2 top-0 shadow-lg"
                                  (click)="checkHasAttractions()" [class.opacity-100]="isShowTripFunctions"
                                  [class.translate-y-[-242px]]="isShowTripFunctions" [class.block]="isShowTripFunctions"
                                  igClickStopPropagation>near_me
                                </mat-icon>
                                <ig-confirm-dialog *ngIf="isShowGPSConfirm" [isShowIcon]="false"
                                  class="!w-[300px] right-2 bottom-20 absolute" (confirm)="gpsDirections()"
                                  (cancel)="directions()" igClickStopPropagation
                                  text="Do you want to start this itinerary from your current location?">
                                </ig-confirm-dialog>

                                <mat-icon *ngIf="isMobile" matTooltip="Show on the map" matTooltipPosition="left"
                                  class="opacity-0 hidden transition-all duration-150 z-10 absolute left-2 top-0 shadow-lg"
                                  (click)="showMobileMap(dayIndex)" [class.opacity-100]="isShowTripFunctions"
                                  [class.translate-y-[-302px]]="
                                    isShowTripFunctions
                                  " [class.block]="isShowTripFunctions">room
                                </mat-icon>
                              </div>
                            </div>

                            <div *ngIf="isEditMode"
                              class="absolute bottom-10 w-full flex justify-center cursor-pointer gap-2 z-20">
                              <span class="bg-white rounded-full px-4 flex">
                                <mat-icon [class.!text-[#e9e9e9]]="dayIndex === 0"
                                  [class.!cursor-not-allowed]="dayIndex === 0" (click)="moveDayLeft(dayIndex)"
                                  matTooltip="Move this day to the left"
                                  class="!w-8 !h-8 rounded-full bg-white text-blue-900 text-[20px] leading-[30px] text-center cursor-pointer">
                                  swipe_left_alt
                                </mat-icon>
                                <mat-icon #editDayMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="editDayMenu"
                                  class="!w-8 !h-8 rounded-full bg-white text-blue-900 text-[16px] leading-[30px] text-center">
                                  border_color
                                </mat-icon>
                                <mat-icon (click)="isShowDeleteDayConfirm = true"
                                  class="!w-8 !h-8 rounded-full bg-white text-red-400 text-[20px] leading-[30px] text-center">
                                  delete_forever
                                </mat-icon>

                                <mat-icon [class.!text-[#e9e9e9]]="
                                    dayIndex === currentTrip.days.length - 1
                                  " [class.!cursor-not-allowed]="
                                    dayIndex === currentTrip.days.length - 1
                                  " (click)="moveDayRight(dayIndex)" matTooltip="Move this day to the right"
                                  class="!w-8 !h-8 rounded-full bg-white text-blue-900 text-[20px] leading-[30px] text-center cursor-pointer">
                                  swipe_right_alt
                                </mat-icon>

                                <div class="w-full absolute left-0 bottom-9 flex items-center justify-center">
                                  <ig-confirm-dialog *ngIf="isShowDeleteDayConfirm" class="!relative !w-[300px]"
                                    (confirm)="deleteDay(dayIndex)" (cancel)="isShowDeleteDayConfirm = false"
                                    igClickStopPropagation
                                    text="Are you sure you want to remove this day? You still need to save the changes after the deletion.">
                                  </ig-confirm-dialog>
                                </div>

                                <mat-menu #editDayMenu="matMenu" class="ig-text-color-edit !rounded-md px-6 py-2">
                                  <div igClickStopPropagation (keydown)="onKeyDown($event)">
                                    <p class="text-lg font-semibold text-gray-600 !mb-3">
                                      Edit This Date
                                    </p>
                                    <div>
                                      <input matInput [matDatepicker]="editDatePicker" [(ngModel)]="newDay"
                                        [matDatepickerFilter]="dateFilter" (dateChange)="editDateChange()"
                                        class="w-0 h-0 opacity-0 absolute" />

                                      <span (click)="editDatePicker.open()"
                                        class="flex items-center w-fit rounded-full py-1 text-gray-500 gap-3 cursor-pointer">
                                        <mat-icon class="!w-5 !h-5 text-[20px]">border_color</mat-icon>
                                        <span class="text-md">{{
                                          editDayText || day.dateText
                                          }}</span>
                                      </span>
                                      <mat-datepicker #editDatePicker></mat-datepicker>
                                    </div>
                                    <!--                                              <div class="mt-4">-->
                                    <!--                                                <ig-field [control]="titleForm.get('note')" label="Note"-->
                                    <!--                                                          mode="textarea"-->
                                    <!--                                                          icon="note" igClickStopPropagation>-->
                                    <!--                                                </ig-field>-->
                                    <!--                                              </div>-->

                                    <ig-button cls="w-[80px] mt-4" (trigger)="
                                        editDay(day, editDayMenuTrigger)
                                      ">
                                      ok
                                    </ig-button>
                                  </div>
                                </mat-menu>
                              </span>
                            </div>

                            <div cdkDropList (cdkDropListDropped)="
                                onAttractionDrop($event, day)
                              ">
                              <div *ngIf="isEditMode" class="mx-[30px] mb-2">
                                <ig-search-attractions *ngIf="currentTrip"
                                  [existing]="currentTrip.days[dayIndex].attractions" [style]="'light'"
                                  [hubName]="hubName" [searchFor]="'all'" [limit]="dayAttractionLimit"
                                  (addPlace)="addPlace($event, dayIndex)"></ig-search-attractions>
                              </div>

                              <span [class.ig-hide]="!isEditMode || day.note" #editDayNoteMenuTrigger="matMenuTrigger"
                                [matMenuTriggerFor]="editDayNoteMenu" (click)="titleForm.get('note').setValue('')"
                                class="flex items-center w-fit rounded-full bg-white mx-auto py-1 px-3 text-gray-500 gap-3 border border-dashed border-gray-300 cursor-pointer">
                                <mat-icon class="!w-4 !h-4 text-[16px]">note</mat-icon>
                                <span class="text-xs">Add a note for this day</span>
                              </span>

                              <div [class.ig-hide]="!day.note"
                                class="w-full px-8 text-sm text-gray-500 mt-2 mb-4 text-center relative">
                                {{ day.note }}
                                <mat-icon [class.ig-hide]="!isEditMode" (click)="
                                    titleForm.get('note').setValue(day.note)
                                  " #editDayNoteMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="editDayNoteMenu"
                                  class="bg-white !w-6 !h-6 text-center leading-[22px] text-[14px] rounded-full text-blue-950 cursor-pointer absolute right-6 -top-2">
                                  border_color
                                </mat-icon>
                              </div>

                              <mat-menu #editDayNoteMenu="matMenu"
                                class="ig-text-color-edit ig-tp-note-edit !rounded-md px-6 py-2">
                                <div igClickStopPropagation (keydown)="onKeyDown($event)">
                                  <p class="text-lg font-semibold text-gray-600 !mb-3">
                                    {{ day.note ? "Edit Note" : "Add a Note" }}
                                  </p>

                                  <div class="mt-4">
                                    <ig-field [control]="titleForm.get('note')" label="Note" mode="textarea" icon="note"
                                      igClickStopPropagation>
                                    </ig-field>
                                  </div>

                                  <ig-button class="" cls="w-[80px]" (trigger)="
                                      editDayNote(day, editDayNoteMenuTrigger)
                                    ">
                                    ok
                                  </ig-button>
                                </div>
                              </mat-menu>

                              @for (attraction of day.attractions; let
                              attractionIndex = $index; track attractionIndex) {

                              <ig-trip-plan-list [day]="day" [attractionIndex]="attractionIndex"
                                [isEditMode]="isEditMode" [isShowPlans]="isShowPlans"></ig-trip-plan-list>

                              <div *ngIf="isEditMode" class="flex items-center justify-center mt-3">
                                <ig-create-edit-plan [attraction]="attraction"></ig-create-edit-plan>
                              </div>

                              <div class="rounded-2xl flex h-[90px] mt-3 relative px-8 cursor-pointer" cdkDrag
                                [cdkDragDisabled]="!isEditMode" (click)="clickAttraction(attraction)"
                                [cdkDragData]="attraction" (cdkDragStarted)="isDragging = true"
                                (cdkDragEnded)="isDragging = false" [class.!cursor-grab]="isEditMode">
                                <ig-image [src]="attraction.item.cover?.source" cls="w-full h-full rounded-l-2xl"
                                  class="w-[calc(23%+70px)] rounded-l-2xl"></ig-image>
                                <div class="w-[77%] rounded-r-2xl bg-[#e6e6fb] py-3 px-5 relative text-xs">
                                  <p class="text-purple-400 font-semibold text-[13px] max-lines-2">
                                    {{ attraction.item.name }}
                                    <span *ngIf="attraction.item['rating']" class="gap-1 items-start inline-flex">
                                      <mat-icon class="text-[gold] !w-2.5 !h-4 text-[12px]">star</mat-icon>
                                      <span class="text-gray-500 font-normal text-xs">{{
                                        attraction.item["rating"] }}</span>
                                    </span>
                                  </p>

                                  <p *ngIf="getCategoryText(attraction.item)" class="max-lines-1">
                                    {{ getCategoryText(attraction.item) }}
                                  </p>
                                  <p *ngIf="attraction.item['timeOneLine']" class="max-lines-1 relative">
                                    <mat-icon *ngIf="attraction.item['isExpired']"
                                      class="!w-4 !h-4 text-[14px] leading-5 mr-1 text-red-400"
                                      matTooltip="This event is expired">info</mat-icon>{{
                                    attraction.item["timeOneLine"] }}
                                  </p>
                                  <p class="max-lines-1">
                                    {{ attraction.item.address.address || attraction.item.address }}
                                  </p>

                                  <ng-container *ngIf="isEditMode">
                                    <div
                                      class="flex justify-center items-center absolute top-2 right-2 rounded-full w-6 h-6 bg-white cursor-pointer"
                                      [matTooltip]="
                                        day.attractions.length === 1 &&
                                        (attraction.prePlans?.length ||
                                          attraction.postPlans?.length)
                                          ? 'Delete this attraction will remove all the plans within this day.'
                                          : ''
                                      " (click)="
                                        deleteAttraction(day, attractionIndex)
                                      " igClickStopPropagation>
                                      <mat-icon class="!w-4 !h-4 text-[16px] text-red-400">
                                        delete_forever
                                      </mat-icon>
                                    </div>
                                    <div [class.ig-hide]="
                                        currentTrip.days.length === 1
                                      "
                                      class="flex justify-center items-center absolute top-2 right-9 rounded-full w-6 h-6 bg-white cursor-pointer">
                                      <mat-icon class="!w-4 !h-4 text-[16px] text-blue-900"
                                        #moveDayMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="moveDayMenu"
                                        igClickStopPropagation>
                                        swap_horiz
                                      </mat-icon>
                                      <mat-menu #moveDayMenu="matMenu" class="ig-text-color-edit !rounded-md px-6 py-2">
                                        <div igClickStopPropagation (keydown)="onKeyDown($event)">
                                          <p class="text-lg font-semibold text-gray-600 !mb-3">
                                            Move to Date
                                          </p>

                                          <mat-form-field appearance="outline" igClickStopPropagation>
                                            <mat-label>Date</mat-label>
                                            <mat-select [(ngModel)]="moveToDate">
                                              <mat-option *ngFor="
                                                  let d of getAvailableDates(
                                                    day
                                                  )
                                                " [value]="d.dateText">{{ d.dateText }}
                                              </mat-option>
                                            </mat-select>
                                          </mat-form-field>
                                          <p *ngIf="
                                              day.attractions.length === 1 &&
                                              (day.attractions[0].prePlans
                                                ?.length ||
                                                day.attractions[0].postPlans
                                                  ?.length)
                                            " class="text-xs flex items-center gap-2 -translate-y-2.5 text-gray-600">
                                            <mat-icon class="text-red-400 !w-4 !h-4 text-[14px]">warning
                                            </mat-icon>
                                            Moving this attraction will remove
                                            all the plans within this day.
                                          </p>

                                          <ig-button class="" cls="w-[80px]" (trigger)="
                                              saveMoveDate(
                                                day,
                                                attractionIndex,
                                                moveDayMenuTrigger
                                              )
                                            ">
                                            OK
                                          </ig-button>
                                        </div>
                                      </mat-menu>
                                    </div>
                                  </ng-container>
                                </div>
                                <div
                                  class="rounded-full w-6 h-6 flex items-center justify-center bg-[gold] text-gray-600 font-semibold absolute left-6 -top-2.5">
                                  {{ attractionIndex + 1 }}
                                </div>
                              </div>
                              }
                            </div>

                            <ig-trip-plan-list *ngIf="day.attractions.last()?.postPlans?.length" [day]="day"
                              [attractionIndex]="day.attractions.length - 1" [planType]="'postPlans'"
                              [isEditMode]="isEditMode" [isShowPlans]="isShowPlans"></ig-trip-plan-list>

                            <div *ngIf="isEditMode && day.attractions.length"
                              class="flex items-center justify-center mt-3">
                              <ig-create-edit-plan [attraction]="day.attractions.last()"
                                type="postPlans"></ig-create-edit-plan>
                            </div>

                            @if (!day.attractions.length) {
                            <p
                              class="mt-20 text-gray-400 px-10 text-[16px] leading-6 text-center flex flex-col items-center gap-4">
                              <ig-image [src]="
                                  'https://pic.rmb.bdstatic.com/bjh/user/d0283ed699ccb053bbce0789865cd9b5.jpeg'
                                " cls="!w-20 !h-20 rounded-full"></ig-image>
                              You haven't added any events or places to visit to
                              this day yet. Go to Events or Places and start
                              building your itinerary.
                            </p>
                            }
                          </mat-tab>
                          }
                        </mat-tab-group>
                      </div>
                    </div>
                  </div>
                  }
                </div>
                } }
              </div>

              <div #aiTripContainer *ngIf="!currentTrip"
                class="flex justify-center text-sm text-gray-500 h-10 pt-2 bg-[#f3f6fc] w-[calc(100%-8px)] z-10 absolute bottom-0 left-0"
                [class.!h-full]="isAIThinking" [class.ig-tp-ai-trip-container-thinking]="isAIThinking"
                [class.translate-y-[4vh]]="!isAIThinking && isMobile && !trips.length"
                [class.opacity-0]="!isAIThinking && !isAIGenerateCompleted && !trips.length">
                <!-- <p *ngIf="trips.length &&
                    frontendSettings?.ai?.travelBuddy?.cityName &&
                    !isAIThinking &&
                    !isLoadingTrips &&
                    !isDeletingTrip
                  " class="mb-5 mx-auto0">
                  Need ideas? Try out
                  <span class="underline cursor-pointer text-blue-500" #aiTripMenuTrigger="matMenuTrigger"
                    [matMenuTriggerFor]="aiTripMenu">AI suggested itineraries</span>
                </p> -->
                <p *ngIf="isAIThinking && !streamWordCount" class="flex flex-col items-center">
                  <span class="flex gap-3">
                    <mat-icon class="text-[20px]">smart_toy</mat-icon>
                    AI is thinking
                  </span>
                  <ig-loading-dot class="-translate-x-8"></ig-loading-dot>
                </p>
                <div #aiTripContentContainer class="ig-tp-ai-trip-content-container overflow-y-auto mb-20"
                  [class.mx-8]="streamWordCount > 0"></div>

                <div *ngIf="isAIGenerateCompleted"
                  class="absolute bottom-0 py-4 px-8 w-full h-fit flex items-center justify-end gap-6">
                  <button class="bg-[#41abf3] text-white rounded-[4px] py-2 px-4 upper-btn"
                    #saveAiTripMenuTrigger="matMenuTrigger" [matMenuTriggerFor]="saveAiTripMenu">
                    Add this to my trip
                  </button>
                  <p class="underline cursor-pointer" (click)="backToTripList()">
                    Back to my trip list
                  </p>

                  <mat-menu #saveAiTripMenu="matMenu" class="ig-text-color-edit !rounded-md px-6 py-2">
                    <div igClickStopPropagation (keydown)="onKeyDown($event)">
                      <p class="text-lg font-semibold text-gray-600 !mb-3">
                        Set a title & date for this trip
                      </p>

                      <ig-field [control]="titleForm.get('title')" label="Title" icon="title"
                        igClickStopPropagation></ig-field>

                      <span (click)="setDatePicker.open()"
                        class="flex items-center w-fit rounded-full py-1 text-gray-500 gap-3 cursor-pointer -translate-y-2.5">
                        <mat-icon class="!w-5 !h-5 text-[20px]">border_color</mat-icon>
                        <span class="text-md">{{
                          editDayText || "(Select a date)"
                          }}</span>
                      </span>
                      <mat-datepicker #setDatePicker></mat-datepicker>

                      <input matInput [matDatepicker]="setDatePicker" [(ngModel)]="newDay"
                        (dateChange)="editDateChange()" class="w-0 h-0 opacity-0" />

                      <ig-button class="" cls="w-[80px]" [isAsync]="true" [disabled]="
                          !editDayText || !titleForm.get('title').value
                        " (trigger)="
                          addAITripToMyTrip($event, saveAiTripMenuTrigger)
                        ">
                        OK
                      </ig-button>
                    </div>
                  </mat-menu>
                </div>
              </div>
            </div>

            <div *ngIf="!isMobile || (isMobile && isShowingMapOnMobile)"
              class="w-[60%] h-full rounded-br-3xl top-[68px] left-0 mobile:z-10 mobile:absolute mobile:w-full mobile:h-[calc(100%-68px)]">
              <div *ngIf="isNavigationShowing" class="absolute bottom-10 left-0 w-full h-fit bg-transparent flex z-20">
                <div class="w-[40%] mobile:hidden"></div>
                <ig-direction-navigation class="block flex-grow" [map]="googleMap"
                  [currentItinerary]="currentTrip?.days[daysTabGroup.selectedIndex]"
                  [directionResults]="directionResults" [travelMode]="currentTrip?.travelMode"
                  (onExit)="isNavigationShowing = false">
                </ig-direction-navigation>
              </div>

              <ig-google-map #googleMap class="h-full w-full rounded-br-3xl" [markers]="mapMarkers"
                [useDefaultMarkerClickStyle]="false" [zoom]="4" (onMarkerClick)="markerClick($event)"></ig-google-map>
            </div>

            <mat-menu #aiTripMenu="matMenu" class="ig-text-color-edit !rounded-md px-6 py-2 mobile:px-0">
              @if (trips?.length >= 12) {
              <div class="flex items-center">
                You have created too many trips.
              </div>
              } @else {
              <div igClickStopPropagation (keydown)="onKeyDown($event)">
                @if
                (frontendSettings.customSettings.tripPlanner.defaultAISuggestedItineraries?.length
                > 0) { @for (itinerary of
                frontendSettings.customSettings.tripPlanner.defaultAISuggestedItineraries;
                let i = $index; track i) {
                <button mat-menu-item (click)="createAITrip(itinerary.title)">
                  <mat-icon class="rotate-90 !text-gray-400">pan_tool_alt</mat-icon>
                  {{ itinerary.title }}
                </button>
                } } @else {
                <button mat-menu-item (click)="
                    createAITrip(
                      'Suggest a one-day itinerary in ' + frontendSettings.ai.travelBuddy.cityName
                    )
                  ">
                  <mat-icon class="rotate-90 !text-gray-400">pan_tool_alt</mat-icon>
                  Suggest a one-day itinerary in
                  {{ frontendSettings.ai.travelBuddy.cityName }}
                </button>
                <button mat-menu-item (click)="
                    createAITrip(
                      'Suggest a foodie itinerary in ' + frontendSettings.ai.travelBuddy.cityName
                    )
                  ">
                  <mat-icon class="rotate-90 !text-gray-400">pan_tool_alt</mat-icon>
                  Suggest a foodie itinerary in
                  {{ frontendSettings.ai.travelBuddy.cityName }}
                </button>
                <button mat-menu-item (click)="
                    createAITrip(
                      'Suggest a kid-friendly itinerary in ' + frontendSettings.ai.travelBuddy.cityName
                    )
                  ">
                  <mat-icon class="rotate-90 !text-gray-400">pan_tool_alt</mat-icon>
                  Suggest a kid-friendly itinerary in
                  {{ frontendSettings.ai.travelBuddy.cityName }}
                </button>
                }
              </div>
              }
            </mat-menu>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
}